<template>
  <div id="myModal" class="modall" v-if="show_image">
  <span id="cclose" class="close" @click="show_image = false">&times;</span>
    <img class="modall-content" v-bind:src="imageBaseUrl + alimentare_imagine">
    <div id="caption"></div>
  </div>

  <div class="video-modal" v-if="show_video" @click.self="closeVideoModal">
    <div class="video-modal-window">
      <button class="video-modal-close" type="button" @click.stop="closeVideoModal">&times;</button>
      <video
        ref="homeVideo"
        class="video-player"
        controls
        preload="metadata"
        @play="videoPaused = false"
        @pause="videoPaused = true"
        @ended="videoPaused = true"
      >
        <source src="/fc_faz_final2.mp4" type="video/mp4">
        Browserul nu suporta redarea video.
      </video>
      <div class="video-actions">
        <button class="btn btn-sm btn-secondary" type="button" @click="seekVideo(-10)">-10s</button>
        <button class="btn btn-sm btn-secondary" type="button" @click="toggleVideoPlayback">
          {{ videoPaused ? 'Play' : 'Pauza' }}
        </button>
        <button class="btn btn-sm btn-secondary" type="button" @click="seekVideo(10)">+10s</button>
      </div>
    </div>
  </div>

  <div class="home">
    <div style="display:flex; align-items:center; justify-content:space-between; margin:10px; padding-top:8px;">
      <button class="btn btn-sm btn-warning" style="font-size: 1em; font-weight: bold; margin:0;" @click="intreaba_logout">
        {{nume}} - {{marca}}</button>
      <button
        v-if="pushSupported"
        class="btn btn-sm"
        :style="{
          fontSize: '1.05em',
          width: '34px',
          height: '34px',
          padding: '0',
          border: 'none',
          background: 'transparent',
          margin: '0',
          opacity: pushEnabled ? '0.95' : '0.35',
          filter: pushEnabled ? 'none' : 'grayscale(1)'
        }"
        @click="activeazaNotificariPush"
        :disabled="pushBusy"
        :title="pushEnabled ? 'Dezactiveaza notificari' : 'Activeaza notificari'"
        aria-label="Notificari push"
      >
        <font-awesome-icon :icon="pushEnabled ? 'bell' : 'bell-slash'" />
      </button>
    </div>
    <button class="btn btn-info instructions-button" type="button" @click="openVideoModal">
      Instructiuni
    </button>
    <div class="container-md">
      <div class="flex-box-2">
        <button class="btn btn-sm btn-secondary " @click="schimba_data(-1)">&lt;</button>
        <p style="margin:0.4em 0em 0.3em;" id="data_pontaj" onclick="data_change(0);">{{data_a}}</p> 
        <button class="btn btn-sm btn-secondary " @click="schimba_data(1)">&gt;</button>
      </div>
    <div v-if="!fc_new && !selecteaza_inginer && !traseu_edit && !od_new_data && !lucrare_edit">
      <nav aria-label="lista_fcs">
        <ul class="pagination">
          <li class="page-item"><a class="page-link" @click="docnew">+</a></li>
          <li class="page-item" aria-current="page" 
            :class="{active: fc_index==index}"  
            v-for="(item, index) in fcs" v-bind:key="index"
            @click="select_document(index)">
            <span class="page-link">{{item.utilaj__inventar}}</span>
          </li>
          <li class="page-item" aria-current="page"
            :class="{active: od_selected}"
            v-for="(item, index) in ods" v-bind:key="index"
            @click="select_documentOD(index)">
          <span class="page-link">OD</span>
          </li>
        </ul>
      </nav>
      <template v-if="fc_selected && taxeFc">
        <TaxeUtilaj v-if="taxeFc.utilaj?.taxe?.length" :key="`utilaj-${fcActual.id}`" titlu="Mașină" :inventar="taxeFc.utilaj.inventar" :taxe="taxeFc.utilaj.taxe" :deschisa-initial="taxeDeschise" />
        <TaxeUtilaj v-if="taxeFc.remorca?.taxe?.length" :key="`remorca-${fcActual.id}`" titlu="Remorcă" :inventar="taxeFc.remorca.inventar" :taxe="taxeFc.remorca.taxe" :deschisa-initial="taxeDeschise" />
      </template>
      <div class="card" v-if="fc_selected">
        
        <div class="card-header">
          <!-- <i style="display: inline;" class="svg-icon bi bi-wrench"></i> -->
          <p style="display: inline;">Inceput {{fcs[fc_index].ora_in}}</p> - <button class="btn btn-sm btn-success" v-if="fcs[fc_index].data_out==null" @click="incheie_timp">Opreste</button>
          <p style="display: inline;" v-if="fcs[fc_index].data_out!=null" >Incheiat {{fcs[fc_index].ora_out}}</p>
          <p style="display: inline;"> - {{fcs[fc_index].punct_lucru__nume}}</p>
        </div>
        <div class="card-body">
          <div class="input-group mb-1">
            <button class="input-group-text" style="width: 100%" 
            @dblclick="intreaba_alt_index"
            :disabled="fcs[fc_index].satre!==0"
            >Index initial: {{fcs[fc_index].index_in}}, Exploatare {{fcs[fc_index].exploatare}}</button>
          </div>
          
          <div class="input-group mb-1" v-if="fcActual?.faz && poate_remorca && !setare_accesorii">
            <div class="input-group-prepend">
              <span class="input-group-text" style="padding-left:2px;width:25px;"><font-awesome-icon icon="trailer"/>:</span>
            </div>
            <button class="btn btn-sm btn-secondary flex-grow-1"
                @click="remorca_change" 
                v-if="!setare_remorca"
                :disabled="fcs[fc_index].satre!==0">
                {{ fcs[fc_index].remorca 
                    ? `${fcs[fc_index].remorca.inventar} - schimbă` 
                    : "Atașează remorca" }}
                
            </button>
            <FSelect style="background-color:lightgray;"
                v-if="setare_remorca" 
                v-bind:options="remorci_type" 
                :initial="fcs[fc_index].remorca?fcs[fc_index].remorca.tip:this.remorci_type[0]" 
                v-bind:valoare="remorci" 
                v-on:fselect="remorcaSelectat"/>
            <FSearchSelect style="width:60%; display: inline-flex;"
                v-if="setare_remorca"
                :options="remorci"
                :favorite-ids="remorciPrioritare"
                :utilaj="remorca_s"
                v-on:utilaj_selectat="remorca_selectat"
                >
            </FSearchSelect>
          </div>
          <div class="input-group mb-3" v-if="setare_remorca && fcActual?.faz">
            <button class="btn btn-sm btn-danger" style="width: 50%;" @click="remorca_delete">Șterge remorca</button>
            <button class="btn btn-sm btn-success" style="width: 50%;" @click="remorca_save">Salvează remorca</button>
          </div>

          <div class="input-group mb-1" v-if="!fcActual?.faz && accesoriiDisponibilePeFoaie && !setare_remorca && !setare_accesorii">
            <div class="input-group-prepend">
              <span class="input-group-text" style="padding-left:2px;width:25px;"><font-awesome-icon :icon="['fas', 'wrench']"/>:</span>
            </div>
            <button class="btn btn-sm btn-secondary flex-grow-1"
                :disabled="fcActual.satre !== 0 || operatieAccesoriiInCurs"
                @click="editeazaAccesorii">
                {{ etichetaButonAccesorii() }}
            </button>
          </div>
          <div v-if="setare_accesorii && !fcActual?.faz" class="mb-3">
            <AccesoriiSelect
              v-model="accesoriiDraft"
              :options="accesoriiCatalog"
              :favorite-ids="accesoriiPrioritare"
              :disabled="accesoriiBusy || accesoriiCatalogBusy || accesoriiVerificareBusy"
              @selecteaza-accesoriu="verificaAccesoriuSelectat"
            />
            <div class="input-group">
              <button class="btn btn-sm btn-warning" style="width:50%" :disabled="accesoriiBusy || accesoriiVerificareBusy" @click="renuntaAccesorii">Renunță</button>
              <button class="btn btn-sm btn-success" style="width:50%" :disabled="accesoriiBusy || accesoriiCatalogBusy || accesoriiVerificareBusy" @click="salveazaAccesorii">Salvează accesorii</button>
            </div>
          </div>

          <div v-if="!setare_remorca && !setare_accesorii">
            <div class="input-group" :class="{'mb-1': fcs[fc_index].faz, 'mb-3': !fcs[fc_index].faz}">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:125px;">Index final:</span>
              </div>
              <input v-model="fcs[fc_index].index_out" type="number" class="form-control" id="updatePontajNoapte" min="1" :disabled="fcs[fc_index].satre!==0" >
              <div class="input-group-append">
                <span class="input-group-text" :style="{backgroundColor: fcs[fc_index].lucrare != null ? 'green' : 'whitesmoke', width: '50px'}" @click="editeaza_lucrare">&nbsp;
                  <font-awesome-icon :icon="['fas', 'wrench']" :style="{color: fcs[fc_index].lucrare != null ? 'white' : 'black'}"/></span>
              </div>
            </div>
            <div class="input-group mb-3" v-if="fcs[fc_index].faz">
              <div class="input-group-prepend">
                  <span class="input-group-text" style="width:125px;">Ore motor:</span>
                </div>
                <input v-model="fcs[fc_index].fct_motor" type="number" class="form-control" id="updateFct_Motor" min="0" max="24" :disabled="fcs[fc_index].satre !== 0">
                <input v-model="fcs[fc_index].fct_cmotor" type="number" class="form-control" id="updateFct_cMotor" disabled>
            </div>
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:125px;">Rezervor initial:</span>
              </div>
              <input v-model="fcs[fc_index].rezervor_in" type="number" class="form-control" id="updatePontajNoapte" min="1" :disabled="fcs[fc_index].satre!==0">
              <span class="input-group-text" style="width:50px;">final:</span>
              <input v-model="fcs[fc_index].rezervor_out" type="number" class="form-control" id="updatePontajNoapte" min="1" :disabled="fcs[fc_index].satre!==0">
            </div>
          
            <div class="input-group mb-3">
              <div class="input-group-text alimentari-wrap" style="width: 100%">Alimentari:&nbsp; <b>{{ total_alimentari }}</b> &emsp;

                <button class="btn btn-sm btn-dark" v-for="alim in fcs[fc_index].alimentari" v-bind:key="alim.id"
                :style="stilButonAlimentare(alim)"
                :disabled="(alim_edit && alim_id !== alim.id ) || fcs[fc_index].satre!==0" 
                @click="alimentare_show(alim)">{{alim.alimentare}}</button>
                
                <button class="btn btn-sm btn-dark alimentari-add-btn" style="display: block; margin-left: auto;" 
                :disabled="alim_edit || fcs[fc_index].satre!==0" 
                @click="alimentare_add">
                  Adauga
                </button>
              </div>
              
              <div class="card" style="width:100%" v-if="alim_edit">
                <form @submit.prevent="alimentare_save">
                  <div class="card-body">
                    
                    <div class="input-group mb-1">
                      <div class="input-group-prepend">
                        <span class="input-group-text" style="width:100px;">Cantitate:</span>
                      </div>
                      <input type="number" class ="form-control" v-model="alimentare_litri" min="1" max="2000" step="0.01" placeholder="-- litri" required>
                    </div>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text" style="width:100px;">De la:</span>
                      </div>
                      <input type="text" class="form-control" v-model="alimentare_de_la" placeholder="Nume sau NR AUTO" required>
                    </div>
                    <div class="mb-3" style="display:flex; align-items:center; justify-content:flex-start; text-align:left;">
                      <input
                        id="alimentare_interes_personal"
                        type="checkbox"
                        v-model="alimentare_interes_personal"
                      >
                      <label style="margin:0 0 0 8px;" for="alimentare_interes_personal">
                        Folosita in interes personal
                      </label>
                    </div>
                  
                    <div class="input-group mb-1">
                      <div class="input-group-prepend">
                          <span class="input-group-text" style="width:100px;">Document:</span>
                      </div>
                          <span class="input-group-text" id="stare_change_file" @click="show_image=true"><b>{{alimentare_este_document}}</b></span>
                        <!-- <input type="text" class="form-control" disabled value="fara" id="stare_doc_name" onclick="alert('valeu')"/> -->
                      <div class="input-group-append">
                        <span class="input-group-text" id="stare_change_file" onclick="document.getElementById('i_input').click()"><b>Schimba</b></span>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer" style="padding-left: 2px; padding-right: 2px;">
                    <button class="btn btn-primary" style="width:80px;padding: 5px;" type="submit">Salveaza</button>&nbsp;
                    <button class="btn btn-warning" style="width:80px; padding: 5px;" type="button" @click='alimentare_close'>Uita</button>&nbsp;
                    <button class="btn btn-danger" style="width:80px; padding: 5px;" type="button" @click='alimentare_sterge'>Sterge</button>&nbsp;
                  </div>
                </form>  
              </div> 
              
            </div>
            <table v-if="fcs[fc_index].faz" style="width: 100%;" >
              <tr class="input-group-text mb-1 " style="text-align: left;"
                v-for="(item, index) in fcs[fc_index].transp" v-bind:key="index"
                @click="arata_cursa(index)">
                <td width="50%">
                {{ item.plecare }}-{{ item.sosire }} 
                </td>
                <td width="25%" style="text-align:right;">
                  {{((item.km_plin+item.km_gol) ).toFixed()}}km
                </td>
                <td width="25%" style="text-align: right;">
                  {{((item.ckm_plin+item.ckm_gol) ).toFixed() }}km
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <button class="btn btn-sm btn-success" @click="arata_cursa(-1)" :disabled="fcs[fc_index].satre!=0">Adauga traseu</button>
                </td>
              </tr>
            </table> 
            <textarea class="form-control" v-model="fcs[fc_index].detalii_executie" placeholder="Detalii executie" :disabled="fcs[fc_index].satre!==0"></textarea>
          </div>
        </div>
        <ul class="list-group list-group-flush" v-if="!setare_remorca && !setare_accesorii">
            <li class="list-group-item" v-if="fcs[fc_index].satre==2">Confirmat de {{fcs[fc_index].inginer_nume}}</li>
            <li class="list-group-item">
              <a href="#" @click.prevent="trimite_la_confirmat" v-if="fcs[fc_index].satre==0">Trimite la Confirmat - Inginer</a>
              <a href="#" @click.prevent="retrage_la_confirmat" v-if="fcs[fc_index].satre==1">Retrage de la {{fcs[fc_index].inginer_nume}}</a>
              </li>
            <li class="list-group-item" v-if="fcs[fc_index].satre==0">
              <button class="btn btn-sm btn-danger" style="width:100%" @click="sterge_document">Sterge Foaie</button>
              </li>  
          </ul>
      </div>  

      <div class="card" v-if="od_selected">
        <div class="card-header">
          <p style="display: inline;">Ordin de deplasare</p>
          <p style="display: inline;"> - {{ods[od_index].punct_lucru__nume}}</p>
          <p style="display: inline" v-if="ods[od_index].utilaj!=null">&nbsp;[ {{ ods[od_index].utilaj__inventar }} ]</p>
        </div>
        <div class="card-body">
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style=" padding-top: .5em; padding-bottom: .5em;">{{ods[od_index].data_from_}} - </span>
            </div>
            <input v-model="ods[od_index].data_to" type="date" class="form-control" id="updateODto" :min="ods[od_index].data_from__" :disabled="ods[od_index].satre!==0  || ods[od_index].data_from__ !== data_">
          </div>
          <textarea class="form-control" v-model="ods[od_index].lucrare" placeholder="Detalii:" :disabled="ods[od_index].satre !== 0 || ods[od_index].data_from__ !== data_"></textarea>
        </div>
        <ul class="list-group list-group-flush">
              <li class="list-group-item" v-if="ods[od_index].satre == 2">Zile Confirmate: {{ ods[od_index].confirmat }} de {{ ods[od_index].inginer_nume }}</li>
              <li class="list-group-item">
                <a href="#" @click.prevent="trimite_la_confirmatOD" v-if="ods[od_index].satre == 0 && ods[od_index].data_from__ == data_">Trimite la Confirmat - Inginer</a>
                <a href="#" @click.prevent="retrage_la_confirmat" v-if="ods[od_index].satre == 1 && ods[od_index].data_from__==data_">Retrage de la {{ ods[od_index].inginer_nume }}</a>
                </li>
              <li class="list-group-item" v-if="ods[od_index].satre == 0 && ods[od_index].data_from__ == data_">
                <button class="btn btn-sm btn-danger" style="width:100%" @click="sterge_document">Sterge Ordin </button>
                </li>  
            </ul>
      </div>

    </div>  
    <div class="card" v-if="od_new_data">
      <div class="card-header">
        Selectie date ordin
      </div>
      <div class="card-body">
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text" style=" padding-top: .5em; padding-bottom: .5em; width: 130px;">De la </span>
          </div>
          <input v-model="od_data_from" type="date" class="form-control">
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text" style=" padding-top: .5em; padding-bottom: .5em; width: 130px;">Pana la </span>
          </div>
          <input v-model="od_data_to" type="date" class="form-control">
        </div>
      </div>
      <div class="card-footer">
          <button class="btn btn-info float-left" style="width: 130px;" @click='init_od' :disabled='!initODEn'> Initiaza OD</button>&nbsp;
          <button class="btn btn-warning float-right" style="width:130px;" @click='close_doc'>Uita</button>
        </div>
    </div>

    <div class="card" v-if="fc_new">
      <div class="card-header">
        <p style="display: inline;">Inceput {{fcn_data}}</p> 
        &nbsp;
      </div>
      <div class="card-body">
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text" style="width:125px;">Santier:</span>
          </div>
          <FSelectSantier v-bind:options="santiere" v-model="sass" />
        </div>
        
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text" style="width:125px;">Utilaj tip:</span>
          </div>
          <FSelect v-bind:options="ut" :initial="'Favorite'" v-bind:valoare="uts" :disabled="operatieAccesoriiInCurs" v-on:fselect="utilajSelectat"/>
        </div>

        <div class="input-group mb-3">
          <FSearchSelect
              :options="uts"
              :utilaj="utilaj_s"
              :disabled="operatieAccesoriiInCurs"
              v-on:utilaj_selectat="utilaj_selectat"
              >
          </FSearchSelect>
        </div>

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" style="width:125px;">Index initial:</span>
          </div>
          <input type="number" class="form-control" min="1" v-model="utilaj_i">
        </div>
        <div class="input-group mb-3" v-if="utilaj_poateremorca">
          <div class="input-group-prepend">
            <span class="input-group-text" style="padding-left:2px;width:25px;"><font-awesome-icon icon="trailer"/>:</span>
          </div>
          <FSelect style="background-color:lightgray;" 
              ref="selectTipRemorca"
              v-bind:options="remorci_type" 
              v-bind:valoare="remorci" 
              v-on:fselect="remorcaSelectat"/>
          <FSearchSelect style="width:60%; display: inline-flex;"
              :options="remorci"
              :favorite-ids="remorciPrioritare"
              :utilaj="remorca_s"
              v-on:utilaj_selectat="remorca_selectat"
              >
          </FSearchSelect>
        </div>
        <p v-if="utilaj_poateremorca" class="small text-muted mt-n2 mb-3">Remorca se folosește numai la inițierea unui FAZ.</p>

      </div>

      <div class="card-footer">
        <div class="home-action-grid">
          <button class="btn btn-primary" @click='init_fc' :disabled='!initFcEn'>Initiaza FC</button>
          <button class="btn btn-warning" @click='close_doc'>Uita</button>
          <button class="btn btn-success" @click='init_faz' :disabled='!initFazEn'>Initiaza FAZ</button>
          <button class="btn btn-info" @click='select_data_od' :disabled='!initODEn'>Initiaza OD</button>
          <a v-if="poateAccesaPlanificator" class="btn planner-button" :href="plannerUrl">PLANIFICATOR</a>
        </div>
      </div>
      
    </div> 

    <SelectInginer ref="seling"
      :ingineri="ingineri"
      :busy="inginerBusy"
      :selecteaza_inginer="selecteaza_inginer"
      v-on:uita_inginer_selectat="uita_inginer_selectat"
      v-on:inginer_confirmare="inginer_confirmare"
      titlu="Inginer Confirmare">
    </SelectInginer>

    <div class="card" style="width:100%" v-if="traseu_edit">
      <form @submit.prevent="traseu_save">
        <div class="card-body">
      
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:100px;">Plecare:</span>
            </div>
            <input type="text" class ="form-control" v-model="traseu_plecare" placeholder="locatie" required :disabled="fcs[fc_index].satre > 0">
          </div>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:100px;">Sosire:</span>
            </div>
            <input type="text" class="form-control" v-model="traseu_sosire" placeholder="locatie" required :disabled="fcs[fc_index].satre > 0">
          </div>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:100px;">Km plin:</span>
            </div>
            <input type="number" class="form-control" v-model="traseu_km_plin" min="0" max="2000" step=".1" required :disabled="fcs[fc_index].satre > 0">
            <div class="input-group-append">
                <span class="input-group-text" style="width:80px;">{{ traseu_ckm_plin }}</span>
            </div>
          </div>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:100px;">Km gol:</span>
            </div>
            <input type="number" class="form-control" v-model="traseu_km_gol" min="0" max="2000" step=".1" required :disabled="fcs[fc_index].satre > 0">
            <div class="input-group-append">
              <span class="input-group-text" style="width:80px;">{{ traseu_ckm_gol }}</span>
            </div>
          </div>
           <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:100px;">Incarcatura:</span>
            </div>
            <!-- <FSelect v-bind:options="tip_i" v-bind:selected="traseu_tip_incarcatura" v-on:fselect="traseu_tip_incarcatura_selectat" /> -->
            <select v-model="traseu_tip_incarcatura" class="form-control" required :disabled="fcs[fc_index].satre > 0">
              <option v-for="(option, index) in tip_i" v-bind:key="index" v-bind:value="option">{{ option }}</option>
            </select>
          </div>
          <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:100px;">Cantitate:</span>
              </div>
              <input type="number" class="form-control" v-model="traseu_cantitate" min="0" max="80000" step="0.1" required :disabled="fcs[fc_index].satre > 0">
          </div>
          <div class="input-group mb-1">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width:100px;">Nr. curse:</span>
                </div>
                <input type="number" class="form-control" v-model="traseu_nr_curse" min="1" max="1000" required :disabled="fcs[fc_index].satre > 0">
          </div>
          <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width:100px;">Basculari:</span>
                  </div>
                  <input type="number" class="form-control" v-model="traseu_basculari" min="0" :max="traseu_nr_curse*10" required :disabled="fcs[fc_index].satre > 0">
                  <div class="input-group-append">
                    <span class="input-group-text" style="width:80px;">{{ traseu_cbasculari }}</span>
                  </div>
            </div>
            <textarea class="form-control" v-model="traseu_detalii_transport" placeholder="Detalii transport" :disabled="fcs[fc_index].satre > 0"></textarea>
        </div>
        

        <div class="card-footer" style="padding-left: 2px; padding-right: 2px;">
          <button class="btn btn-primary" style="width:80px;padding: 5px;" type="submit" :disabled="fcs[fc_index].satre > 0">Salveaza</button>&nbsp;
          <button class="btn btn-warning" style="width:80px; padding: 5px;" type="button" @click='traseu_close'>Uita</button>&nbsp;
          <button class="btn btn-danger" style="width:80px; padding: 5px;" type="button" @click='traseu_sterge' :disabled="fcs[fc_index].satre > 0">Sterge</button>&nbsp;
        </div>
      </form>  
    </div> 
   

    <div class="card" style="width:100%" v-if="lucrare_edit">
      <form @submit.prevent="lucrare_save">
        <div class="card-body" style="padding: 4px;">
          <div :class="fcs[fc_index].satre > 0 ?'text-muted':'text-white bg-success'" style="border: 1px solid; border-color: lightslategrey; border-radius: 7px; margin-bottom: 5px; font-weight: bold;">Schimburi / Reparații</div>
          <div class="row">
            <div class="col" style="padding-right: 0px; margin-right: 0px;">
              <div class="form-switch" style="text-align: left;">
                <input class="form-check-input" type="checkbox" v-model="ulei_motor" :disabled="fcs[fc_index].satre > 0">&nbsp;
                <label class="form-check-label" >Ulei motor</label>
              </div>
            </div>
            <div class="col" style="padding-left: 0px; margin-left: 0px;">
              <div class="form-switch"  style="text-align: left;">
                <input class="form-check-input" type="checkbox" v-model="filtru_ulei_motor" :disabled="fcs[fc_index].satre > 0">&nbsp;
                <label class="form-check-label" >Filtru ulei motor</label>
              </div>
            </div>
          </div>

          <div class="row">
              <div class="col" style="padding-right: 0px; margin-right: 0px;">
              </div>
              <div class="col" style="padding-left: 0px; margin-left: 0px;">
                <div class="form-switch"  style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="filtru_combustibil" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Filtru combustibil</label>
                </div>
              </div>
          </div>
          <div class="row">
            <div class="col" style="padding-right: 0px; margin-right: 0px;">
            </div>
            <div class="col" style="padding-left: 0px; margin-left: 0px;">
              <div class="form-switch"  style="text-align: left;">
                <input class="form-check-input" type="checkbox" v-model="filtru_aer" :disabled="fcs[fc_index].satre > 0">&nbsp;
                <label class="form-check-label" >Filtru aer</label>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col" style="padding-right: 0px; margin-right: 0px;">
              </div>
              <div class="col" style="padding-left: 0px; margin-left: 0px;">
                <div class="form-switch"  style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="filtru_polen" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Filtru polen</label>
                </div>
              </div>
          </div>
          <div class="row">
                <div class="col" style="padding-right: 0px; margin-right: 0px;">
                </div>
                <div class="col" style="padding-left: 0px; margin-left: 0px;">
                  <div class="form-switch"  style="text-align: left;">
                    <input class="form-check-input" type="checkbox" v-model="filtru_adblue" :disabled="fcs[fc_index].satre > 0">&nbsp;
                    <label class="form-check-label" >Filtru AdBlue</label>
                  </div>
                </div>
            </div>
          <div class="row">
                <div class="col" style="padding-right: 0px; margin-right: 0px;">
                </div>
                <div class="col" style="padding-left: 0px; margin-left: 0px;">
                  <div class="form-switch"  style="text-align: left;">
                    <input class="form-check-input" type="checkbox" v-model="filtru_uscator" :disabled="fcs[fc_index].satre > 0">&nbsp;
                    <label class="form-check-label" >Filtru uscator</label>
                  </div>
                </div>
            </div>
          
          <div class="d-flex align-items-center">
            <!-- <span class="flex-grow-1" style="border-bottom: 1px solid;"></span> -->
            <span class="px-3">500 ore +</span>
            <span class="flex-grow-1" style="border-bottom: 1px solid;"></span>
          </div>
          
          <div class="row">
            <div class="col" style="padding-right: 0px; margin-right: 0px;">
              <div class="form-switch" style="text-align: left;">
                <input class="form-check-input" type="checkbox" v-model="ulei_cutie" :disabled="fcs[fc_index].satre > 0">&nbsp;
                <label class="form-check-label" >Ulei cutie</label>
              </div>
            </div>
            <div class="col" style="padding-left: 0px; margin-left: 0px;">
              <div class="form-switch"  style="text-align: left;">
                <input class="form-check-input" type="checkbox" v-model="filtru_ulei_cutie" :disabled="fcs[fc_index].satre > 0">&nbsp;
                <label class="form-check-label" >Filtru ulei cutie</label>
              </div>
            </div>
          </div> 
          <div class="row">
              <div class="col" style="padding-right: 0px; margin-right: 0px;">
                <div class="form-switch" style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="ulei_punte" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Ulei punte</label>
                </div>
              </div>
              <div class="col" style="padding-left: 0px; margin-left: 0px;">
              </div>
            </div> 
          <div class="d-flex align-items-center">
            <!-- <span class="flex-grow-1" style="border-bottom: 1px solid;"></span> -->
            <span class="px-3">1000 ore +</span>
            <span class="flex-grow-1" style="border-bottom: 1px solid;"></span>
          </div>
          
          <div class="row">
            <div class="col" style="padding-right: 0px; margin-right: 0px;">
              <div class="form-switch" style="text-align: left;">
                <input class="form-check-input" type="checkbox" v-model="ulei_hidraulic" :disabled="fcs[fc_index].satre > 0">&nbsp;
                <label class="form-check-label" >Ulei hidraulic</label>
              </div>
            </div>
            <div class="col" style="padding-left: 0px; margin-left: 0px;">
              <div class="form-switch"  style="text-align: left;">
                <input class="form-check-input" type="checkbox" v-model="filtru_ulei_hidraulic" :disabled="fcs[fc_index].satre > 0">&nbsp;
                <label class="form-check-label" >Filtru ulei hidraulic</label>
              </div>
            </div>
          </div> 
          
            <textarea class="form-control" v-model="lucrare_detalii" placeholder="Detalii lucrari efectuate" rows="4" :disabled="fcs[fc_index].satre > 0"></textarea>
        </div>
      

        <div class="card-footer" style="padding-left: 2px; padding-right: 2px;">
          <button class="btn btn-primary" style="width:80px;padding: 5px;" type="submit" :disabled="fcs[fc_index].satre > 0">Salveaza</button>&nbsp;
          <button class="btn btn-warning" style="width:80px; padding: 5px;" type="button" @click='lucrare_close'>Uita</button>&nbsp;
          <button class="btn btn-danger" style="width:80px; padding: 5px;" type="button" @click='lucrare_sterge' :disabled="fcs[fc_index].satre > 0">Sterge</button>&nbsp;
        </div>
      </form>  
    </div>
    
    </div>   
    <confirmare ref="dialogDeConfirmare"></confirmare>
  </div>

  

<input type="file" hidden accept="image/*; capture=camera " id="i_input" @change="ichange">


</template>

<script>
import axios from 'axios'
import strftime from '../helpers/strftime'
import FSelect from '../components/FSelect.vue'
import FSelectSantier from '../components/FSelectSantier.vue'
import FSearchSelect from '../components/FSearchSelect.vue'
import AccesoriiSelect from '../components/AccesoriiSelect.vue'
import TaxeUtilaj from '../components/TaxeUtilaj.vue'
import SelectInginer from '../components/SelectInginer.vue'
import resizeImage from '../helpers/resizeImage'
import { API_BASE_URL, IMAGE_BASE_URL } from '../config/api'
import { deletePushSubscription, getCurrentPushSubscription, getPushDiagnostics, isPushSupported, savePushSubscription, subscribeToPushNotifications, unsubscribeFromPushNotifications } from '../helpers/pushNotifications'

import Confirmare from '../components/Confirmare.vue'

// import Intreaba2 from '../components/Intreaba2.vue'
// import { createConfirmDialog } from 'vuejs-confirm-dialog'

// const useConfirmBeforeAction = (action, props) => {
//   const { reveal, onConfirm } = createConfirmDialog(Intreaba2, props)
//   onConfirm(action)
//   reveal()
// }
const axi = axios.create({
  baseURL: API_BASE_URL
})
let isRefreshing = false;

function isTokenExpired(token) {
  try {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  } catch (e) { console.log(e); }
  return false;
}


export default {
  name: 'Home',
  components:{
    FSelect,
    FSelectSantier,
    FSearchSelect,
    AccesoriiSelect,
    TaxeUtilaj,
    SelectInginer,
    Confirmare,
  },

  data(){
    return{
      nume:'',
      marca:'',
      plannerAccesPermis: false,
      plannerUrl: null,
      fcs:[],
      // Taxele FC-ului curent (mașina și remorca), de la rest_fc_faz_taxe.
      taxeFc: null,
      // FC/FAZ-ul abia pornit: casetele de taxe se deschid singure prima dată.
      fcPornitAcum: null,
      ingineri: [],
      impegati: [],
      santiere:[],
      ut: [],
      remorci_type: ['Bena', 'Cisterna', 'Remorca', 'Trailer', 'Vagon'],
      remorci: [],
      remorciFavorite: [],
      remorciConexiuni: [],
      autentificat: false,
      data: null,
      data_: '',
      data_a: '',
      fc_index: -1,
      fc_selected: false,
      fc_new: false,
      fcn_data : '',
      fcn_inv : '',
      fcn_index : '',
      uts: [],
      remorca: null,
      remorca_s: '',
      setare_remorca: false,
      setare_accesorii: false,
      accesoriiCatalog: [],
      accesoriiCatalogBusy: false,
      accesoriiVerificareBusy: false,
      accesoriiEdit: false,
      accesoriiDraft: [],
      accesoriiFoaieId: null,
      accesoriiBusy: false,
      accesoriiFavorite: [],
      accesoriiConexiuni: [],
      initBusy: false,
      inginerBusy: false,
      trimitereDeVerificat: null,
      confirmareBusy: false,
      utilajLoading: false,
      statusBusy: false,
      remorcaLoading: false,
      accesoriiContext: 0,
      utilaj_s: '----',
      utilaj_id: -1,
      utilaj_i: -1,
      utilaj_ii: -1,
      utilaj_new_rezervor_in: 0,
      utilaj_poateremorca: false,
      sass: 'Favorite',
      od_index: -1,
      od_selected: false,

      selecteaza_inginer: false,
      alim_edit: false,

      alim_id: null,
      alimentare_litri: '',
      alimentare_de_la: '',
      alimentare_interes_personal: false,
      alimentare_este_document: 'nu',
      alimentare_imagine_noua: null,
      alimentare_imagine: null,
      imageBaseUrl: IMAGE_BASE_URL,
      alimentare_fc: 0,
      show_image: false,
      show_video: false,
      videoPaused: true,
      pushSupported: false,
      pushEnabled: false,
      pushBusy: false,

      ods:[],

      initFcEn: false,
      initFazEn: false,
      initODEn: false,

      od_new_data: false,
      od_data_from: null,
      od_data_to: null,

      traseu_edit: false,
      traseu_plecare: '',
      traseu_sosire: '',
      traseu_km_plin: 0,
      traseu_km_gol: 0,
      traseu_ckm_plin: 0, 
      traseu_ckm_gol: 0,
      traseu_nr_curse: 1,
      traseu_cantitate: 0,
      traseu_tip_incarcatura: '',
      traseu_detalii_transport: '',
      traseu_id: null,
      traseu_basculari: 0,
      traseu_cbasculari: 0,
      tip_i: [],

      lucrare_edit: false,
      ulei_motor: false,
      filtru_ulei_motor: false,
      filtru_combustibil: false,
      filtru_aer: false,
      filtru_polen: false,
      filtru_adblue: false,
      filtru_uscator: false,
      ulei_cutie: false,
      filtru_ulei_cutie: false,
      ulei_punte: false,
      ulei_hidraulic: false,
      filtru_ulei_hidraulic: false,
      gresare: false,
      lucrare_detalii: "",
    }
  },
  computed: {
    poateAccesaPlanificator() {
      return this.$store.state.authenticated && this.plannerAccesPermis === true && Boolean(this.plannerUrl);
    },
    fcActual() {
      return this.fc_selected ? this.fcs[this.fc_index] : null;
    },
    taxeDeschise() {
      return this.fcPornitAcum != null && String(this.fcActual?.id) === String(this.fcPornitAcum);
    },
    accesoriiDisponibilePeFoaie() {
      return Array.isArray(this.fcActual?.accesorii);
    },
    accesoriiModificate() {
      return this.accesoriiEdit && !this.aceleasiAccesorii(this.accesoriiDraft, this.fcActual?.accesorii || []);
    },
    operatieAccesoriiInCurs() {
      return this.accesoriiBusy || this.initBusy || this.inginerBusy || this.confirmareBusy || this.utilajLoading || this.statusBusy || this.remorcaLoading;
    },
    accesoriiPrioritare() {
      return this.combinaPrioritati(this.accesoriiConexiuni, this.accesoriiFavorite);
    },
    remorciPrioritare() {
      return this.combinaPrioritati(this.remorciConexiuni, this.remorciFavorite);
    },
    total_alimentari: function() {
      return (this.fcs.length > 0 && this.fc_index > -1 ? this.fcs[this.fc_index].alimentari.reduce((acc, item) => acc + item.alimentare, 0).toFixed(2) : 0);
    },
  },
  watch: {
    // La deschiderea paginii (după rest_fc_faz_status), la refresh și la schimbarea FC-ului.
    'fcActual.id': {
      handler(id) { this.incarcaTaxe(id); },
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('checkAuthenticated')

  },

  beforeRouteLeave() {
    return this.confirmaAbandonAccesorii();
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.avertizeazaAccesoriiNesalvate);
  },

  async mounted(){
    window.addEventListener('beforeunload', this.avertizeazaAccesoriiNesalvate);
    this.data = new Date();
    this.data_a = strftime("%a  %d.%m.%Y", this.data, "RO");
    this.pushSupported = isPushSupported();
    window.testClearSessionFlow = async () => {
      const clearSessionUrl = `${(API_BASE_URL || '').replace(/\/$/, '')}/rest_fc_faz_clear_session/`;
      await fetch(clearSessionUrl, {
        method: 'POST',
        credentials: 'include',
      });
      window.location.reload();
    };
    
    // this.autentificat = this.$store.state.authenticated;
    // if(!this.autentificat){
    //   await this.$store.dispatch("rrefAuthenticated");
    // }

    this.autentificat = this.$store.state.authenticated;
    if(!this.autentificat){
      this.$router.push("/login");
    }else{
      //axios.defaults.headers.Authorization= `Bearer ${this.$store.state.authToken}`;
      
      axi.interceptors.request.use((config) => {
        const token = this.$store.state.authToken
        config.headers = config.headers || {};
        if ((token) && !isTokenExpired(token)) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
        (error) => Promise.reject(error)
      );

      axi.interceptors.response.use(
        (response) => {
          return Promise.resolve(response);
        },
        async (error) => {
          const originalRequest = error.config;
          //alert(error.response.status);
          if ((error.response?.status === 401 ) && originalRequest && !originalRequest._retry) {
            originalRequest._retry = true;
            if (isRefreshing) {
              return await new Promise(resolve => {
                setTimeout(() => resolve(axi(originalRequest)), 2000);
              });
              // this.$store.dispatch('logout');
              // this.$router.push("/login");
              // isRefreshing = false;
            }
            isRefreshing = true;
            try {
              await this.$store.dispatch('rrefreshToken');
              isRefreshing = false;
              return await axi(originalRequest);
            } catch (err) {
              isRefreshing = false;
              await this.$store.dispatch('logout');
              this.$router.push("/login");
              return Promise.reject(err);
            }
          }
          return Promise.reject(error);
        }
      );
      
      this.ref();
      await this.refreshPushStatus();
      await this.intreabaNotificariPushDacaEnevoie();
    }


  },
  methods: {
    zileRamase(dataExpirare) {
      const [an, luna, zi] = dataExpirare.split('-').map(Number);
      const azi = new Date();
      azi.setHours(0, 0, 0, 0);
      return Math.round((new Date(an, luna - 1, zi) - azi) / 86400000);
    },
    taxeRecalculate(raspuns) {
      // Zilele se schimbă de la o zi la alta; nu ne bazăm pe ce s-a salvat ieri.
      const caseta = c => c && {
        ...c,
        taxe: (c.taxe || [])
          .map(t => ({ ...t, zile_ramase: this.zileRamase(t.data_expirare) }))
          .sort((x, y) => x.zile_ramase - y.zile_ramase),
      };
      return { utilaj: caseta(raspuns.utilaj), remorca: caseta(raspuns.remorca) };
    },
    async incarcaTaxe(fcId) {
      if (!fcId) { this.taxeFc = null; return; }
      const cheie = `taxe_fc_${fcId}`;
      // 1) instant, din ce s-a văzut ultima dată pe telefonul ăsta
      let salvat = null;
      try { salvat = JSON.parse(localStorage.getItem(cheie) || 'null'); } catch (e) { salvat = null; }
      this.taxeFc = salvat ? this.taxeRecalculate(salvat) : null;
      // 2) serverul e sursa; fără panoul de loading, pagina nu așteaptă după SAP
      try {
        const { data } = await axi.get(`rest_fc_faz_taxe/${fcId}/`);
        if (String(this.fcActual?.id) !== String(fcId)) return; // între timp s-a ales alt FC
        if (data.ANS === 'OK') {
          this.taxeFc = this.taxeRecalculate(data);
          try { localStorage.setItem(cheie, JSON.stringify(data)); } catch (e) { /* plin sau mod privat */ }
        }
      } catch (e) {
        // 404 sau rețea: rămâne ce era în localStorage, fără eroare pentru șofer
        console.log(e);
      }
    },
    aplicaRaspunsFc(fc) {
      if (!fc?.id) return;
      const target = this.fcs.find(item => String(item.id) === String(fc?.id));
      if (target) Object.assign(target, fc);
      this.confirmaStareTrimitere(fc?.id);
    },
    confirmaStareTrimitere(id) {
      if (this.trimitereDeVerificat && String(this.trimitereDeVerificat.id) === String(id)) this.trimitereDeVerificat = null;
    },
    aceleasiAccesorii(prima, aDoua) {
      const ids = lista => lista.map(item => String(item.id)).sort().join(',');
      return Array.isArray(prima) && Array.isArray(aDoua) && ids(prima) === ids(aDoua);
    },
    combinaPrioritati(primaLista, aDouaLista) {
      return [...new Set([...(primaLista || []), ...(aDouaLista || [])].map(id => String(id)))];
    },
    iduriUtilajeDinConexiuni(utilaje) {
      return [...new Set((Array.isArray(utilaje) ? utilaje : [])
        .map(utilaj => utilaj.utilaj_id ?? utilaj.utilaj?.id ?? utilaj.id)
        .filter(id => id != null)
        .map(id => String(id)))];
    },
    cheieFavoriteLocale(categorie) {
      const utilizator = String(this.nume || 'necunoscut').trim().toLocaleLowerCase('ro');
      return `fcfaz-${categorie}-favorite:${utilizator}`;
    },
    incarcaFavoriteLocale(categorie) {
      const cheie = `${categorie}Favorite`;
      try {
        const favorite = JSON.parse(window.localStorage.getItem(this.cheieFavoriteLocale(categorie)) || '[]');
        this[cheie] = Array.isArray(favorite)
          ? [...new Set(favorite.filter(id => id != null).map(id => String(id)))].slice(0, 12)
          : [];
      } catch (_) {
        this[cheie] = [];
      }
    },
    actualizeazaFavoriteLocale(categorie, utilaje) {
      const cheie = `${categorie}Favorite`;
      const folosite = (Array.isArray(utilaje) ? utilaje : [])
        .map(utilaj => utilaj?.id)
        .filter(id => id != null)
        .map(id => String(id))
        .reverse();
      this[cheie] = [...new Set([...folosite, ...this[cheie]])].slice(0, 12);
      try {
        window.localStorage.setItem(this.cheieFavoriteLocale(categorie), JSON.stringify(this[cheie]));
      } catch (_) {
        // Browser storage can be unavailable; the priority from Conexiuni Utilaje still works.
      }
    },
    async incarcaConexiuniUtilaje() {
      try {
        const { data } = await axi.get('rest_fc_faz_conexiuni_utilaje/');
        return data.ANS === 'OK' && Array.isArray(data.Utilaje) ? data.Utilaje : [];
      } catch (_) {
        // Until UTI exposes this endpoint, existing local favorites continue to work.
        return [];
      }
    },
    eroareOperatie(error, fallback) {
      return error?.response?.data?.MSG || error?.response?.data?.detail || (error?.isAxiosError ? fallback : error?.message) || fallback;
    },
    avertizeazaAccesoriiNesalvate(event) {
      if (!this.accesoriiModificate && !this.operatieAccesoriiInCurs) return;
      event.preventDefault();
      event.returnValue = '';
    },
    reseteazaAccesorii() {
      this.accesoriiContext += 1;
      this.accesoriiEdit = false;
      this.accesoriiDraft = [];
      this.accesoriiFoaieId = null;
      this.setare_accesorii = false;
    },
    confirmaAbandonAccesorii() {
      if (this.operatieAccesoriiInCurs) {
        alert('Așteptați finalizarea operației în curs.');
        return false;
      }
      if (this.accesoriiModificate &&
          !confirm('Aveți accesorii nesalvate. Renunțați la selecție?')) return false;
      this.reseteazaAccesorii();
      return true;
    },
    etichetaButonAccesorii() {
      const accesorii = this.fcActual?.accesorii || [];
      if (!accesorii.length) return 'Atașează accesorii';
      if (accesorii.length === 1) return `${accesorii[0].inventar} - schimbă`;
      return `${accesorii.length} accesorii - schimbă`;
    },
    async incarcaAccesorii() {
      this.accesoriiCatalogBusy = true;
      try {
        const { data } = await axi.get('rest_fc_faz_utilaje/?tip=Accesorii');
        if (data.ANS !== 'OK' || !Array.isArray(data.Utilaje)) throw new Error(data.MSG || 'Catalogul de accesorii nu este disponibil.');
        this.accesoriiCatalog = data.Utilaje;
        this.accesoriiConexiuni = this.iduriUtilajeDinConexiuni(await this.incarcaConexiuniUtilaje());
      } catch (error) {
        alert(this.eroareOperatie(error, 'Nu s-au putut încărca accesoriile.'));
      } finally {
        this.accesoriiCatalogBusy = false;
      }
    },
    async editeazaAccesorii() {
      if (this.operatieAccesoriiInCurs || this.fcActual?.faz || !this.accesoriiDisponibilePeFoaie || this.fcActual.satre !== 0) return;
      this.accesoriiFoaieId = this.fcActual.id;
      this.accesoriiDraft = [...this.fcActual.accesorii];
      this.accesoriiEdit = true;
      this.setare_accesorii = true;
      await this.incarcaAccesorii();
    },
    async verificaAccesoriuSelectat(accesoriu) {
      if (this.accesoriiVerificareBusy || this.operatieAccesoriiInCurs || !this.accesoriiEdit || !accesoriu?.id ||
          this.accesoriiDraft.some(item => String(item.id) === String(accesoriu.id))) return;
      const id = this.accesoriiFoaieId;
      const context = this.accesoriiContext;
      this.accesoriiVerificareBusy = true;
      try {
        const { data } = await axi.post(`rest_fc_faz_verifica_accesoriu/${accesoriu.id}/`, { fc_id: id });
        if (data.ANS !== 'OK') throw new Error(data.MSG || 'Accesoriul nu este disponibil.');
        if (context !== this.accesoriiContext || id !== this.accesoriiFoaieId || !this.accesoriiEdit) return;
        if (!this.accesoriiDraft.some(item => String(item.id) === String(accesoriu.id))) {
          this.accesoriiDraft = [...this.accesoriiDraft, accesoriu];
        }
      } catch (error) {
        if (context === this.accesoriiContext) {
          alert(this.eroareOperatie(error, 'Nu s-a putut verifica accesoriul.'));
        }
      } finally {
        this.accesoriiVerificareBusy = false;
      }
    },
    renuntaAccesorii() {
      if (this.accesoriiBusy) return;
      if (this.accesoriiModificate && !confirm('Renunțați la modificările accesoriilor?')) return;
      this.accesoriiEdit = false;
      this.accesoriiDraft = [];
      this.accesoriiFoaieId = null;
      this.setare_accesorii = false;
    },
    async salveazaAccesorii() {
      const fc = this.fcActual;
      if (this.operatieAccesoriiInCurs || !fc || fc.faz || fc.satre !== 0 || fc.id !== this.accesoriiFoaieId) return;
      const id = fc.id;
      const context = this.accesoriiContext;
      const selectie = [...this.accesoriiDraft];
      this.accesoriiBusy = true;
      try {
        const { data } = await axi.put(`rest_fc_faz_put/${id}/`, { id, accesorii: selectie.map(item => item.id) });
        if (data.ANS !== 'OK') throw new Error(data.MSG || 'Accesoriile nu au fost salvate.');
        if (String(data.fc?.id) !== String(id)) throw new Error('Serverul nu a confirmat foaia actualizată.');
        if (!Array.isArray(data.fc.accesorii)) throw new Error('Serverul nu a confirmat lista accesoriilor.');
        // Only merge the field saved here; the other inputs can contain unsaved edits.
        const target = this.fcs.find(item => String(item.id) === String(id));
        if (target) target.accesorii = data.fc.accesorii;
        this.actualizeazaFavoriteLocale('accesorii', data.fc.accesorii);
        this.confirmaStareTrimitere(id);
        if (context === this.accesoriiContext && this.accesoriiFoaieId === id) {
          this.accesoriiEdit = false;
          this.accesoriiDraft = [];
          this.accesoriiFoaieId = null;
          this.setare_accesorii = false;
        }
      } catch (error) {
        alert(this.eroareOperatie(error, 'Nu s-au putut salva accesoriile.'));
      } finally {
        this.accesoriiBusy = false;
      }
    },
    openVideoModal: function () {
      this.show_video = true;
      this.videoPaused = true;
      this.$nextTick(() => {
        const video = this.$refs.homeVideo;
        if (!video) return;
        video.currentTime = 0;
        video.play().then(() => {
          this.videoPaused = false;
        }).catch(() => {
          this.videoPaused = true;
        });
      });
    },
    closeVideoModal: function (event) {
      if (event && event.stopPropagation) {
        event.stopPropagation();
      }
      const video = this.$refs.homeVideo;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      this.videoPaused = true;
      this.show_video = false;
    },
    seekVideo: function (seconds) {
      const video = this.$refs.homeVideo;
      if (!video) return;
      const durata = Number.isFinite(video.duration) ? video.duration : 0;
      const tinta = video.currentTime + seconds;
      video.currentTime = Math.max(0, Math.min(tinta, durata || tinta));
    },
    toggleVideoPlayback: function () {
      const video = this.$refs.homeVideo;
      if (!video) return;
      if (video.paused) {
        video.play();
        this.videoPaused = false;
      } else {
        video.pause();
        this.videoPaused = true;
      }
    },
    async refreshPushStatus() {
      if (!this.pushSupported) {
        this.pushEnabled = false;
        return;
      }

      try {
        const subscription = await getCurrentPushSubscription();
        this.pushEnabled = subscription != null && Notification.permission === 'granted';
      } catch {
        this.pushEnabled = false;
      }
    },
    async intreabaNotificariPushDacaEnevoie() {
      const pushPromptSessionKey = 'fcfaz_push_prompt_shown';
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

      if (
        !isStandalone ||
        window.__fcfazInstallPromptVisible === true ||
        !this.pushSupported ||
        this.pushEnabled ||
        typeof Notification === 'undefined' ||
        Notification.permission !== 'default' ||
        !this.$refs.dialogDeConfirmare ||
        sessionStorage.getItem(pushPromptSessionKey) === '1'
      ) {
        return;
      }

      sessionStorage.setItem(pushPromptSessionKey, '1');

      const acceptaNotificari = await this.$refs.dialogDeConfirmare.show({
        title: 'Notificari',
        message: 'Doriti sa primiti notificari?',
        okButton: 'Da',
        cancelButton: 'Nu'
      });

      if (acceptaNotificari) {
        await this.activeazaNotificariPush();
      }
    },
    getTelefonPentruPush() {
      const telefonRaw =
        this.$store.state.telefon ||
        localStorage.getItem('telefon') ||
        this.$store.state.username ||
        localStorage.getItem('username') ||
        '';

      const telefon = String(telefonRaw).trim().replace(/\s+/g, '');
      const isTelefonValid = /^(0\d{9}|\+40\d{9}|40\d{9})$/.test(telefon);

      if (!isTelefonValid) {
        throw new Error(`Telefon invalid pentru notificari: "${telefonRaw}"`);
      }

      return telefon;
    },
    async activeazaNotificariPush() {
      if (!this.pushSupported || this.pushBusy) {
        return;
      }

      this.pushBusy = true;
      try {
        if (this.pushEnabled) {
          const subscription = await getCurrentPushSubscription();
          if (subscription) {
            await deletePushSubscription(subscription, {
              telefon: this.$store.state.telefon || this.$store.state.username || '',
              user_id: this.$store.state.userId || null,
            });
          }
          const unsubscribed = await unsubscribeFromPushNotifications();
          if (unsubscribed) {
            this.pushEnabled = false;
            alert('Notificarile push au fost dezactivate pe acest dispozitiv.');
          } else {
            alert('Nu exista notificari push active pe acest dispozitiv.');
          }
        } else {
          const subscription = await subscribeToPushNotifications();
          const telefon = this.getTelefonPentruPush();
          await savePushSubscription(subscription, {
            telefon,
            user_id: this.$store.state.userId || null,
          });
          this.pushEnabled = true;
          alert('Notificarile push au fost activate.');
        }
      } catch (error) {
        const diagnostics = await getPushDiagnostics();
        console.log('[PUSH DEBUG]', diagnostics);
        console.log('[PUSH ERROR]', error);
        alert('Nu s-au putut activa notificarile. Va rugam sa iesiti si sa intrati iar in cont, apoi sa incercati din nou.');
      } finally {
        this.pushBusy = false;
      }
    },
    actualizeazaPlanner(data = {}) {
      this.plannerAccesPermis = data.poate_accesa_planner === true;
      this.plannerUrl = data.planner_url || null;
    },
    ref: function () {
      const context = this.accesoriiContext;
      this.actualizeazaPlanner();
      this.statusBusy = true;
      const panou = document.getElementById("loading");
      panou.style.display = 'flex';
      axi.get('rest_fc_faz_status/')
      .then(date => {
        if (context !== this.accesoriiContext) return;
        if (date.data.ANS==='OK'){
          this.actualizeazaPlanner(date.data);
          this.nume = date.data.Nume;
          this.incarcaFavoriteLocale('accesorii');
          this.incarcaFavoriteLocale('remorci');
          this.marca = date.data.marca;
          this.fcs = [...date.data.fcs];
          this.fcs.forEach(fc => this.confirmaStareTrimitere(fc.id));
          this.ods = [...date.data.ods]
          this.fcs.forEach(e => {
            e["ora_in"] = strftime("%H:%M", new Date(e.data_in))
            let mseconds = e.data_out == null || e.data_out.length < 10 ? (new Date() - new Date(e.data_in)) : (new Date(e.data_out) - new Date(e.data_in))
              let minutes = Math.trunc(mseconds/60000);
              const hours = Math.trunc(minutes/60);
              minutes -= hours*60
              e["exploatare"] = `${hours<10?'0'+hours:''+hours}:${minutes<10?'0'+minutes:''+minutes}`
            })
          this.ingineri = [...date.data.ingineri];
          this.impegati = [...date.data.impegati];
          this.santiere = [...date.data.santiere];
          this.tip_i = [...date.data.tip_i];
          this.ut = ['Favorite',].concat(date.data.ut)
          this.ods.forEach(o => { o['data_from_'] = strftime("%d.%m.%Y", new Date(o.data_from)); o['data_from__'] = o.data_from.substring(0, 10); });
          this.fc_selected = this.fcs.length > 0 ? true : false;
          this.fc_index = this.fcs.length > 0 ? 0 : -1;
          this.od_index = this.fc_index > -1 || this.ods.length < 1 ? -1 : 0;
          this.od_selected = this.od_index > -1;
          this.setare_remorca = false;
        }
        console.log(date.data);
        panou.style.display = "none";
      })
        .catch(e => {
          console.log(e);
          this.handleStatusRequestError(e);
          panou.style.display = "none";
      })
      .finally(() => {
        this.statusBusy = false;
        panou.style.display = 'none';
      });
    },
    handleStatusRequestError: async function(error) {
      const clearSessionAttemptKey = 'fcfaz_clear_session_attempted';

      if (error?.response?.status !== 400) {
        return;
      }

      if (sessionStorage.getItem(clearSessionAttemptKey) === '1') {
        return;
      }

      try {
        sessionStorage.setItem(clearSessionAttemptKey, '1');
        const clearSessionUrl = `${(API_BASE_URL || '').replace(/\/$/, '')}/rest_fc_faz_clear_session/`;
        await fetch(clearSessionUrl, {
          method: 'POST',
          credentials: 'include',
        });
      } catch (clearError) {
        console.log(clearError);
      }

      window.location.reload();
    },
    areDateGpsValide: function(gpsConfirmation, indexKey, rezervorKey) {
      const gpsIndex = Number(gpsConfirmation?.[indexKey]);
      const gpsRezervor = Number(gpsConfirmation?.[rezervorKey]);

      return gpsConfirmation?.required === true &&
        Number.isFinite(gpsIndex) &&
        Number.isFinite(gpsRezervor) &&
        gpsIndex > 0 &&
        gpsRezervor > 0;
    },
    esteAlimentareInteresPersonal: function(alimentare) {
      return alimentare?.interes_personal === true ||
        alimentare?.interes_personal === 'true' ||
        alimentare?.interes_personal === 1 ||
        alimentare?.interes_personal === '1';
    },
    stilButonAlimentare: function(alimentare) {
      if (!this.esteAlimentareInteresPersonal(alimentare)) {
        return null;
      }

      return {
        backgroundColor: 'rgb(255, 193, 7)',
        borderColor: 'rgb(255, 193, 7)',
        color: '#212529',
      };
    },
    valoareIntreaga: function(value) {
      const numberValue = Number(value);
      return Number.isFinite(numberValue) ? Math.round(numberValue) : value;
    },
    valoareCuMaxDouaZecimale: function(value) {
      const textValue = String(value).trim().replace(',', '.');
      const numberValue = Number(textValue);
      if (!Number.isFinite(numberValue)) return value;

      const [intPart, decimalPart = ''] = textValue.split('.');
      const normalizedInt = String(Number(intPart || 0));
      const normalizedDecimals = decimalPart.slice(0, 2);

      return normalizedDecimals.length > 0
        ? `${normalizedInt}.${normalizedDecimals}`
        : normalizedInt;
    },
    intreaba_logout: function(){
      if(confirm("Doriti sa schimbati utilizatorul?")){
        this.$router.push("/login");
      }
    },
    schimba_data: async function(zile){
      const dataa = new Date((new Date(this.data.getTime() + zile * 3600 *24 *1000)).toISOString().substring(0,10));
      if (dataa > new Date()) return;
      if (!this.confirmaAbandonAccesorii()) return;
      const context = this.accesoriiContext;
      this.alim_edit = false;
      this.selecteaza_inginer = false;
      this.traseu_edit = false;
      this.od_new_data = false;
      this.lucrare_edit = false;
      if(dataa <= new Date()){
        this.actualizeazaPlanner();
        this.statusBusy = true;
        this.data = dataa
        this.data_ = dataa.toISOString().substring(0, 10);
        this.data_a = strftime("%a  %d.%m.%Y", this.data, "RO");
        const panou = document.getElementById("loading");
                panou.style.display = 'flex';
        try{
          const resp = await axi.get(`rest_fc_faz_status/?data_in=${this.data.toISOString().substring(0,10)}`)
          if (context !== this.accesoriiContext) return;
          //alert(resp)
          if(resp.status != 200){
            alert(resp.status)
            this.$router.push("/login")
            return
          }
          const data = resp.data;
          if (data.ANS==='OK'){
              this.actualizeazaPlanner(data);
              this.nume = data.Nume;
              this.marca = data.marca;
              this.fcs = [...data.fcs];
              this.fcs.forEach(fc => this.confirmaStareTrimitere(fc.id));
              this.ods = [...data.od];
              this.fcs.forEach(e => {
                e["ora_in"] = strftime("%H:%M", new Date(e.data_in))
                if(e.data_out !==null && e.data_out.length >9){
                  e["ora_out"] = strftime((new Date(e.data_in)).getDay() !== (new Date(e.data_out)).getDay() ? "%H:%M %d.%m.%Y": "%H:%M", new Date(e.data_out))
                }else e["ora_out"] = "--:--"
                let mseconds = e.data_out == null || e.data_out.length < 10 ? (new Date() - new Date(e.data_in)) : (new Date(e.data_out) - new Date(e.data_in))
                let minutes = Math.trunc(mseconds/60000);
                const hours = Math.trunc(minutes/60);
                minutes -= hours*60
                e["exploatare"] = `${hours<10?'0'+hours:''+hours}:${minutes<10?'0'+minutes:''+minutes}h`
              })
            this.ods.forEach(o => { o['data_from_'] = strftime("%d.%m.%Y", new Date(o.data_from)); o['data_from__'] = o.data_from.substring(0, 10); });  
            this.fc_selected = this.fcs.length > 0 ? true: false;
            this.fc_index = this.fcs.length > 0 ? 0 : -1;
            this.od_index = this.fc_index > -1 || this.ods.length < 1 ? -1 : 0;
            this.od_selected = this.od_index > -1;
            this.fc_new = false;
            this.setare_remorca = false;
            }

        }catch(e){
          await this.handleStatusRequestError(e);
          alert(e);
        }finally{
          this.statusBusy = false;
          panou.style.display = 'none';
        }
      }
    },
    close_doc: function(){
      if (!this.confirmaAbandonAccesorii()) return;
      this.fc_new = false;
      this.od_new_data = false;
      this.setare_remorca = false;  
    },
    docnew: function(){
      if (!this.confirmaAbandonAccesorii()) return;
      // ar trebui sa verifici data si sa mai faci ajustari
      // initializari componente;

      this.fcn_data = strftime("%d.%m.%Y %H:%M", new Date(this.data))
      this.fcn_inv=''
      this.fcn_index=''

      this.fc_new = true;
      this.utilaj_s= '----';
      this.utilaj_i = -1;
      this.utilaj_ii = -1;
      this.utilaj_id = -1;
      this.utilaj_new_rezervor_in = 0;
      this.sass = 'SNimic';
      this.initFcEn = false;
      this.initFazEn = false;
      this.initODEn = this.ods.length === 0;
      this.remorca_s = '';
      this.remorca = null;
      this.setare_remorca = false;
      

    },
    poate_remorca: function(){
      return this.fc_index > -1 && (this.fcs[this.fc_index].utilaj__tip === 'Cap Tractor' || this.fcs[this.fc_index].utilaj__tip === 'Autovehicul');
    },

    select_document: function(new_index){
      if (this.fc_index === new_index) return;
      if (!this.confirmaAbandonAccesorii()) return;
      this.setare_remorca = false;
      this.fc_index = new_index;
      this.od_index = -1;
      this.fc_selected = this.fc_index > -1;
      this.od_selected = this.od_index > -1;
    },
    select_documentOD: function (new_index) {
      if (!this.confirmaAbandonAccesorii()) return;
      this.setare_remorca = false;
      this.od_index = new_index;
      this.fc_index = -1;
      this.fc_selected = this.fc_index > -1;
      this.od_selected = this.od_index > -1;
    },
    sterge_document: async function () {
      if (!this.confirmaAbandonAccesorii()) return;
      if (this.od_selected) {
        const od_ = this.ods[this.od_index];
        if (!confirm(`ATENTIE STERGETI Ordin de Deplasare inceput la ${od_.data_from_}?`)) {
          return
        }
        const panou = document.getElementById("loading");
        panou.style.display = 'flex';
        try {
          const resp = await axi.delete(`rest_fc_faz_deleteOD/${od_.id}/`)
          const data = resp.data;
          if (data.ANS === 'OK') {
            this.schimba_data(0)
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          console.log(e)
        }
        panou.style.display = 'none'
        return;
      }
      
      const fc_=this.fcs[this.fc_index];

      if(confirm(`ATENTIE STERGETI document pentru ${fc_.utilaj__inventar} inceput la ${strftime("%H:%M %d/%m.%Y", new Date(fc_.data_in))} ?`)){
        const panou = document.getElementById("loading");
          panou.style.display = 'flex'; 
        try{
          const resp = await axi.delete(`rest_fc_faz_delete/${fc_.id}/`)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.schimba_data(0)
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
      }

    },
    incheie_timp: async function(){
      const fc_=this.fcs[this.fc_index];
      if(confirm(`Opriti timpul de lucru pentru ${fc_.utilaj__inventar} ?`)){
        const panou = document.getElementById("loading");
          panou.style.display = 'flex'; 
        try{
          const formData = {
            id: fc_.id, data_out: (new Date()).toISOString(),
            index_out: fc_.index_out, rezervor_in: this.valoareIntreaga(fc_.rezervor_in), rezervor_out: this.valoareIntreaga(fc_.rezervor_out),
            detalii_executie: fc_.detalii_executie, fct_motor: fc_.fct_motor
          }
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              // #stop task gps
              this.aplicaRaspunsFc(data.fc);
              const gpsStopConfirmation = data.gps_stop_confirmation;
              if (this.areDateGpsValide(gpsStopConfirmation, 'gps_index_out', 'gps_rezervor_out')) {
                const gpsMessage = gpsStopConfirmation.message?.length > 0
                  ? `${gpsStopConfirmation.message}\n\nDoriti sa folositi datele din GPS?`
                  : `Index final GPS: ${gpsStopConfirmation.gps_index_out} km\nRezervor final GPS: ${gpsStopConfirmation.gps_rezervor_out}\n\nDoriti sa folositi datele din GPS?`;
                const useGpsStopValues = await this.$refs.dialogDeConfirmare.show({
                  title: 'Confirmare date GPS',
                  message: gpsMessage,
                  okButton: 'Da',
                  cancelButton: 'Nu'
                });

                if (useGpsStopValues) {
                  const updateResp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, {
                    id: fc_.id,
                    index_out: gpsStopConfirmation.gps_index_out,
                    rezervor_out: this.valoareIntreaga(gpsStopConfirmation.gps_rezervor_out),
                  });
                  const updateData = updateResp.data;
                  if (updateData.ANS === 'OK' && updateData.fc) {
                    Object.assign(this.fcs[this.fc_index], updateData.fc);
                  } else {
                    alert(updateData.MSG || 'Nu am putut actualiza datele finale cu valorile GPS.');
                  }
                }
              }
              let e = this.fcs[this.fc_index];
              e["ora_in"] = strftime("%H:%M", new Date(e.data_in))
                if(e.data_out !==null && e.data_out.length >9){
                  e["ora_out"] = strftime((new Date(e.data_in)).getDay() !== (new Date(e.data_out)).getDay() ? "%H:%M %d.%m.%Y": "%H:%M", new Date(e.data_out))
                }else e["ora_out"] = "--:--"
              // #stop task gps

            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
      }
    },
    remorca_change: async function () {
      if (this.operatieAccesoriiInCurs || !this.fcActual?.faz) return;
      if(this.fcs[this.fc_index].remorca__id === null){
        // cauta in conexiuni si vezi ultima remorca
      }
      this.setare_remorca = true;
    },
    async utilajSelectat(tip){
      if (this.operatieAccesoriiInCurs) return;
      //alert(tip)
      const panou = document.getElementById("loading");
            panou.style.display = 'flex';
      try {
        this.initFcEn = false
        this.initFazEn = false
        const resp = await axi.get(`rest_fc_faz_utilaje/?tip=${tip}`)
        const data = resp.data;
        if (data.ANS==='OK'){
            this.uts = [... data.Utilaje];
          }

      }catch(e){
        console.log(e)
      }
      panou.style.display = 'none'
    },
    async remorcaSelectat(tip){
      const context = this.accesoriiContext;
      //alert(tip)
      const panou = document.getElementById("loading");
      if (tip == '') return;
      panou.style.display = 'flex';
      try {
        const resp = await axi.get(`rest_fc_faz_utilaje/?tip=${tip}`)
        const data = resp.data;
        if (context === this.accesoriiContext && data.ANS==='OK'){
            this.remorci = [... data.Utilaje];
            this.remorciConexiuni = this.iduriUtilajeDinConexiuni(await this.incarcaConexiuniUtilaje());
          }

      }catch(e){
        console.log(e)
      }
      panou.style.display = 'none'
    },

    async utilaj_selectat(dictionar){
      if (!this.confirmaAbandonAccesorii()) return;
      const context = this.accesoriiContext;
      this.utilajLoading = true;
      this.initFcEn = false;
      this.initFazEn = false;
      this.remorca = null;
      this.remorca_s = '';
      const panou = document.getElementById("loading");
      panou.style.display = 'flex'; 
      this.utilaj_s = `${dictionar.inventar}-${dictionar.producator}, ${dictionar.model!=null?dictionar.model:''}`;
      this.utilaj_id = dictionar.id;
      this.utilaj_poateremorca = false;
        try{
          const resp = await axi.get(`rest_fc_faz_utilaj_index/${dictionar.id}/`)
          const data = await resp.data;
          if (context !== this.accesoriiContext || this.utilaj_id !== dictionar.id || !this.fc_new) return;
          if (data.ANS==='OK'){
            this.utilaj_i = data.INDEX
            this.utilaj_ii = data.INDEX
            this.utilaj_new_rezervor_in = data.rezervor_out;
            this.utilaj_poateremorca = data.poate_remorca;

            if (this.utilaj_poateremorca) {
              var tip_rem = data.remorca != null ? data.remorca.tip : this.remorci_type[0];
              if (data.remorca != null) {
                const ok_rem = await this.$refs.dialogDeConfirmare.show({
                  title: 'Remorca',
                  message: `Aveți atașată ${data.remorca.tip} ${data.remorca.inventar}?`,
                  okButton: 'Da',
                  cancelButton: 'Nu'
                });
                if (ok_rem) {
                  this.remorca = data.remorca;
                  this.remorca_s = `${data.remorca.inventar}-${data.remorca.producator ?? ''}, ${data.remorca.model ?? ''}`;
                } else {
                  alert('Nu uitați să selectați remorca / bena atașată.');
                  this.remorca = null;
                  this.remorca_s = '';
                } 
              } else {
                this.remorca_s = '';
                alert('Nu uitați să selectați remorca / bena atașată.');
              }
              console.log('Before DOM update:', this.$refs.selectTipRemorca);
              this.$nextTick(() => {
                console.log('After DOM update:', this.$refs.selectTipRemorca);
                if (this.$refs.selectTipRemorca) {
                  this.$refs.selectTipRemorca.selected = tip_rem;
                  this.$refs.selectTipRemorca.la_schimb();
                }
              });

            }
            // this.remorca = data.remorca;
            // if (this.remorca != null) {
            //   this.remorca_s = `${data.remorca.inventar}-${data.remorca.producator??''}, ${data.remorca.model??''}`;
            // } else {
            //   this.remorca_s = '';
            // }
            if (data.MSG?.length > 0)
              alert(data.MSG)
          }
          
          else{
            alert(data.MSG)
          }
          if (context === this.accesoriiContext && data.ANS === 'OK') {
            this.initFcEn = data.fc_en;
            this.initFazEn = data.faz_en;
          }
          //this.initFcEn = data.fc_en;// ?? false
          //this.initFazEn = data.faz_en;// ?? false

        }catch(e){
          alert(this.eroareOperatie(e, 'Nu s-au putut încărca datele utilajului.'));
          console.log(e)
        }finally{
          this.utilajLoading = false;
          panou.style.display = 'none';
        }
    },

    async remorca_selectat(dictionar){
        if (this.operatieAccesoriiInCurs) return;
        const context = this.accesoriiContext;
        this.remorcaLoading = true;
        const panou = document.getElementById("loading");
            panou.style.display = 'flex'; 
        this.remorca_s = `${dictionar.inventar}-${dictionar.producator}, ${dictionar.model!=null?dictionar.model:''}`;
        this.remorca = dictionar;
        try{
          const resp = await axi.get(`rest_fc_faz_status_remorca/${dictionar.id}/`)
          const data = await resp.data;
          if (context !== this.accesoriiContext) return;
          if (data.ANS=='NOK' && data.MSG?.length > 0)
            alert(data.MSG)
          this.initFazEn = data.faz_en ?? false

        }catch(e){
          console.log(e)
        }finally{
          this.remorcaLoading = false;
          panou.style.display = 'none';
        }
    },

    async init_doc(faz=false){
      if (this.operatieAccesoriiInCurs) return;
      if (faz ? !this.initFazEn : !this.initFcEn) return;
      //alert(this.sass)
      if(this.sass=='SNimic'){
        alert("Alegeti santierul")
        return;
        }

      if (this.utilaj_id > -1){
        if((this.utilaj_ii > -5) && (this.utilaj_ii != this.utilaj_i)) 
        { //alert(`original=${this.utilaj_ii} modificat=${this.utilaj_i}`)
          if(!confirm(`Indexul vechi este ${this.utilaj_ii} iar cel introdus de dumneavoastra este ${this.utilaj_i} doriti sa continuati?`)){
            return;
          } 
        }
        if (this.utilaj_i < 0) {
          alert('Va rog sa introduceti indexul, acesta nu poate fi negativ.');
          return;
        }

        if (faz && this.remorca == null && this.utilaj_poateremorca) {
          this.confirmareBusy = true;
          let ok_rem_init;
          try {
            ok_rem_init = await this.$refs.dialogDeConfirmare.show({
                  title: 'Atenție',
                  message: `Nu aveți remorcă / benă selectată! Inițiați faz-ul fără remorcă? `,
                  okButton: 'Da',
                  cancelButton: 'Nu'
            });
          } finally {
            this.confirmareBusy = false;
          }
          if (!ok_rem_init) {
            return;
          }
        }

        this.initBusy = true;
        let reincarca = false;
        const panou = document.getElementById("loading");
          panou.style.display = 'flex'; 
      
        try{
          const formData = {data_in: this.data.toISOString().substring(0, 10) + (new Date()).toISOString().substring(10,24),
              utilaj: this.utilaj_id,
              index_in: this.utilaj_i,
              faz: faz,
              remorcax: faz ? this.remorca?.id : null,
              rezervor_in: this.valoareIntreaga(this.utilaj_new_rezervor_in), 
              punct_lucru: this.sass}
          const resp = await axi.post(`rest_fc_faz_add/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              if (data.alerta_revizie != null) {
                await this.$refs.dialogDeConfirmare.show({
                  title: data.alerta_revizie.depasita === true ? 'Avertisment revizie' : 'Atenție revizie',
                  message: data.alerta_revizie.mesaj,
                  okButton: 'OK',
                  cancelButton: null,
                  variant: data.alerta_revizie.depasita === true ? 'danger' : 'warning'
                });
              }
              if (data.fc?.id == null) throw new Error('Serverul nu a confirmat foaia creată.');
              this.fcPornitAcum = data.fc.id;
              if (faz && this.remorca?.id) this.actualizeazaFavoriteLocale('remorci', [this.remorca]);
              // #start task gps
              const gpsStartConfirmation = data.gps_start_confirmation;
              if (this.areDateGpsValide(gpsStartConfirmation, 'gps_index_in', 'gps_rezervor_in') && data.fc?.id != null) {
                const gpsMessage = gpsStartConfirmation.message?.length > 0
                  ? `${gpsStartConfirmation.message}\n\nDoriti sa folositi datele din GPS?`
                  : `Index initial GPS: ${gpsStartConfirmation.gps_index_in} km\nRezervor initial GPS: ${gpsStartConfirmation.gps_rezervor_in}\n\nDoriti sa folositi datele din GPS?`;
                const useGpsStartValues = await this.$refs.dialogDeConfirmare.show({
                  title: 'Confirmare date GPS',
                  message: gpsMessage,
                  okButton: 'Da',
                  cancelButton: 'Nu'
                });

                if (useGpsStartValues) {
                  try {
                    const updateResp = await axi.put(`rest_fc_faz_put/${data.fc.id}/`, {
                      id: data.fc.id,
                      index_in: gpsStartConfirmation.gps_index_in,
                      rezervor_in: this.valoareIntreaga(gpsStartConfirmation.gps_rezervor_in),
                    });
                    const updateData = updateResp.data;
                    if (updateData.ANS !== 'OK') {
                      alert(updateData.MSG || 'Nu am putut actualiza datele initiale cu valorile GPS.');
                    }
                  } catch (error) {
                    alert(this.eroareOperatie(error, 'Foaia a fost creată, dar valorile GPS nu au fost confirmate.'));
                  }
                }
              }
              this.fc_new = false;
              this.reseteazaAccesorii();
              reincarca = true;
              // #start task gps
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          alert(this.eroareOperatie(e, 'Nu s-a putut confirma inițierea foii. Selecția este păstrată.'));
        }finally{
          this.initBusy = false;
          panou.style.display = 'none';
        }
        if (reincarca) {
          await this.schimba_data(0);
        }
        
      }

    },

    select_data_od() {
      if (!this.confirmaAbandonAccesorii()) return;
      if (this.sass == 'SNimic') {
        alert("Alegeti santierul")
        return;
      }
      if ((this.utilaj_id < 0) && (!confirm('NU ATI SELECTAT UTILAJUL!\nSunteti sigur ca doriti sa deschideti un Ordin de deplasare?'))) {
        return;

      }
      this.fc_new = false;
      this.od_data_from = this.data.toISOString().substring(0,10);
      this.od_data_to = this.data.toISOString().substring(0,10);
      this.od_new_data = true;
    },

    async init_od() {   
        //verificare date
      const df = Date.parse(this.od_data_from);
      if (isNaN(df)) {
        alert("Verificati data de pornire");
        return;
      }
      if ((new Date() - df) / (86400000) > 37) {
        alert("Data de pornire prea veche");
        return;
      }
       if (new Date() < df) {
        alert("Data de pornire este in viitor");
        return;
      }

      const dt = Date.parse(this.od_data_to);
      if (isNaN(dt)) {
        alert("Verificati data de plecare");
        return;
      }

      if ((dt - df) / (86400000) > 31) {
        alert("Interval prea mare");
        return;
      }
      if (dt < df) {
        alert("Data de sfarsit mai mica ca cea de pornire");
        return;
      }
    
        const panou = document.getElementById("loading");
        panou.style.display = 'flex';

        try {
          const formData = {
            data_from: (new Date(df)).toISOString().substring(0, 10),// + (new Date()).toISOString().substring(10, 24),
            data_to: (new Date(dt)).toISOString().substring(0, 10),
            punct_lucru: this.sass
          }
          if (this.utilaj_id > 0) {
            formData['utilaj'] = this.utilaj_id;
          } else {
            //formData['comanda'] = '000000000'
          }

          const resp = await axi.post(`rest_fc_faz_addOD/`, formData)
          const data = resp.data;
          if (data.ANS === 'OK') {
            this.schimba_data(0);
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          console.log(e)
        }
        panou.style.display = 'none'

      
    },

    async init_faz() {
      await this.init_doc(true);
    },
    async init_fc() {
      await this.init_doc(false);
    },

    intreaba_alt_index: async function(){
      if(confirm("Schimbati indexul initial?")){
        const new_index = parseInt(prompt("Introduceti indexul initial:", this.fcs[this.fc_index].index_in))
        if((isNaN(new_index)) || (new_index < 1)){
          alert("Indexul introdus nu exte un numar valid!")
          return;
        }
        const panou = document.getElementById("loading");
          panou.style.display = 'flex';
        let fc_ = this.fcs[this.fc_index] 
        try{
          const formData = {index_in: new_index}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.aplicaRaspunsFc(data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        this.selecteaza_inginer = false
        panou.style.display = 'none'

      }
    },

    trimite_la_confirmat: async function(){
      if (this.operatieAccesoriiInCurs || !this.fcActual || this.fcActual.satre !== 0) return;
      if (this.accesoriiEdit) {
        alert('Salvați accesoriile sau apăsați Renunță înainte de trimitere.');
        return;
      }
      //verificare index final
      if (this.fcs[this.fc_index].index_out == null ||
        isNaN(this.fcs[this.fc_index].index_out) ||
        (this.fcs[this.fc_index].index_out < this.fcs[this.fc_index].index_in) ||
        ((this.fcs[this.fc_index].index_out - this.fcs[this.fc_index].index_in > this.ore_max()) && !this.fcs[this.fc_index].faz )) {
        alert("Verificati indexul final");
        return;
      }
    
      if(this.fcs[this.fc_index].rezervor_in==null || isNaN(this.fcs[this.fc_index].rezervor_in)||(this.fcs[this.fc_index].rezervor_in < 0) || (this.fcs[this.fc_index].rezervor_in >2999)){
        alert("Verificati Rezervor initial");return;
      }
      if(this.fcs[this.fc_index].rezervor_out==null || isNaN(this.fcs[this.fc_index].rezervor_out)||(this.fcs[this.fc_index].rezervor_out < 0) || (this.fcs[this.fc_index].rezervor_out >2999)){
        alert("Verificati Rezervor final");return;
      }
      let alimentare_total = 0
      let alimentare_total_normala = 0
      let alimentare_total_personala = 0
      this.fcs[this.fc_index].alimentari.forEach( alim => {
        const alimentare = Number(alim.alimentare) || 0;
        const interes_personal = alim.interes_personal === true || alim.interes_personal === 'true' || alim.interes_personal === 1 || alim.interes_personal === '1';
        alimentare_total += alimentare;
        if (interes_personal) {
          alimentare_total_personala += alimentare;
        } else {
          alimentare_total_normala += alimentare;
        }
      });
      const are_alimentari_personale = alimentare_total_personala > 0;
      let diferenta_rezervor = this.fcs[this.fc_index].rezervor_in + (are_alimentari_personale ? alimentare_total_normala : alimentare_total) - this.fcs[this.fc_index].rezervor_out;
      if (diferenta_rezervor < 0){
        if (are_alimentari_personale) {
          alert(`Verificati rezervorul final si alimentarea in interes personal.\nAlimentarea in interes personal trebuie sa acopere consumul facut in interes personal; pentru kilometrii in interes personal se consuma ce s-a alimentat in interes personal.\nSurplus: ${(diferenta_rezervor * -1).toFixed(2)} litri.`);
          return;
        }
        alert(`Verificati Rezervor initial, final, si alimentari\n (surplus ${diferenta_rezervor * -1} litri)!!!\n Ati uitat sa treceti o alimentare?`);
        return;
      }
      let fcu = this.fcs[this.fc_index]
      if (fcu.index_in < fcu.index_out && fcu.rezervor_in == fcu.rezervor_out && fcu.alimentari.length == 0) {
        alert(`Verificati index, rezervor si alimentari!!!\nAveti ${fcu.index_out - fcu.index_in} ore lucrate cu acelasi stoc si fara alimentari!\nAti uitat sa treceti o alimentare?`);
        return;
      }
      if (fcu.fct_motor < 0 || fcu.fct_motor > 24) {
        alert('Verificati orele functionare motor!');
        return;
      }
      if (fcu.faz && fcu.transp.length == 0) {
        alert('Nu aveti date de transport?\nAceasta este o foaie de parcurs!!!')
        return;
      }
      // if (fcu.lucrare == null && confirm("Ați efectuat revizie / lucrări de mentenanță ?")) {
      //   return;
      // }
      if (fcu.lucrare == null) {
        this.confirmareBusy = true;
        let ok;
        try {
          ok = await this.$refs.dialogDeConfirmare.show({
            title: 'confirmare',
            message: 'Ați efectuat revizie / lucrări de mentenanță ?',
            okButton: 'NU',
            cancelButton: 'Da'
          });
        } finally {
          this.confirmareBusy = false;
        }
        if (!ok) {
          this.editeaza_lucrare();
          return;
        }
      }
      
      this.selecteaza_inginer = true;
    },

    trimite_la_confirmatOD: function () {
      if (this.operatieAccesoriiInCurs) return;
      //verificare index final
      this.selecteaza_inginer = true;
    },

    uita_inginer_selectat: function(){
      if (this.inginerBusy) return;
      this.selecteaza_inginer = false
    },

    inginer_confirmare: async function(ing){
      if (this.operatieAccesoriiInCurs || !ing?.id) return;
      if (!this.od_selected && (this.accesoriiEdit || !this.fcActual || this.fcActual.satre !== 0)) return;
      const fc = this.fcActual;
      const od = this.od_selected ? this.ods[this.od_index] : null;
      if (!fc && !od) return;
      this.inginerBusy = true;
      const panou = document.getElementById("loading");
      panou.style.display = 'flex';
      try {
        if (od) {
          const formData = {
            id: od.id,
            data_to: od.data_to.length === 10 ? od.data_to : od.data_from__,
            inginer: ing.id,
            lucrare: od.lucrare,
            satre: 1,
          };
          const { data } = await axi.put(`rest_fc_faz_updateOD/${od.id}/`, formData);
          if (data.ANS !== 'OK') throw new Error(data.MSG || 'Ordinul nu a fost trimis.');
          const target = this.ods.find(item => String(item.id) === String(od.id));
          if (target && String(data.od?.id) === String(od.id)) Object.assign(target, data.od);
          this.selecteaza_inginer = false;
          return;
        }
        if (!Array.isArray(fc.accesorii)) throw new Error('Serverul nu a furnizat lista accesoriilor pentru această foaie. Reîncărcați pagina.');
        let formData = {
          id: fc.id,
          data_out: (fc.data_out == null || fc.data_out.length < 10) ? (new Date()).toISOString() : fc.data_out,
          inginer: ing.id, index_out: fc.index_out,
          rezervor_in: this.valoareIntreaga(fc.rezervor_in), rezervor_out: this.valoareIntreaga(fc.rezervor_out),
          fct_motor: fc.fct_motor, detalii_executie: fc.detalii_executie, satre: 1,
          accesorii: fc.accesorii.map(item => item.id),
        };
        if (this.trimitereDeVerificat && String(this.trimitereDeVerificat.id) === String(fc.id)) {
          const anterior = this.trimitereDeVerificat;
          const modificat = Object.keys(formData).some(key => {
            if (key === 'data_out') return fc.data_out != null && String(fc.data_out) !== String(anterior.data_out);
            if (key === 'accesorii') return JSON.stringify([...formData[key]].sort()) !== JSON.stringify([...(anterior[key] || [])].sort());
            return String(formData[key] ?? '') !== String(anterior[key] ?? '');
          });
          if (modificat) {
            throw new Error('Datele diferă față de trimiterea anterioară neconfirmată. Reîncărcați foaia pentru verificare înainte de a trimite modificările.');
          }
          // Keep data_out unchanged when retrying a request whose response was lost.
          formData = anterior;
        }
        this.trimitereDeVerificat = formData;
        const { data } = await axi.put(`rest_fc_faz_put/${fc.id}/`, formData);
        if (data.ANS !== 'OK') {
          this.trimitereDeVerificat = null;
          throw new Error(data.MSG || 'Foaia nu a fost trimisă.');
        }
        if (String(data.fc?.id) !== String(fc.id) || Number(data.fc?.satre) !== 1) {
          throw new Error('Serverul nu a confirmat trimiterea foii.');
        }
        if (!Array.isArray(data.fc.accesorii)) throw new Error('Serverul nu a confirmat lista accesoriilor.');
        this.aplicaRaspunsFc(data.fc);
        this.trimitereDeVerificat = null;
        this.selecteaza_inginer = false;
      } catch (error) {
        if (error.response && error.response.status < 500) this.trimitereDeVerificat = null;
        alert(this.eroareOperatie(error, 'Trimiterea nu a fost confirmată. Datele sunt păstrate; puteți reîncerca.'));
      } finally {
        this.inginerBusy = false;
        panou.style.display = 'none';
      }
    },

    retrage_la_confirmat: async function () {
      const panou = document.getElementById("loading");
      if (this.od_selected) {
        let od_ = this.ods[this.od_index]
        if (od_.satre == 2) return
        panou.style.display = 'flex';
        try {
          const formData = {
            id: od_.id,
            satre: 0
          }
          const resp = await axi.put(`rest_fc_faz_updateOD/${od_.id}/`, formData)
          const data = resp.data;
          if (data.ANS === 'OK') {
            Object.assign(this.ods[this.od_index], data.od);
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          console.log(e)
        }
        this.selecteaza_inginer = false
        panou.style.display = 'none'
        return;
      }
        
        let fc_ = this.fcs[this.fc_index] 
        if(fc_.satre==2)return
        
        panou.style.display = 'flex';
        
        try{
          const formData = {id: fc_.id,
            satre: 0}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.aplicaRaspunsFc(data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        this.selecteaza_inginer = false
        panou.style.display = 'none'
    },

    ichange: async function(e){
      //alert(e.target.files[0]);
      const config = {file: e.target.files[0], maxSize: 800}
      const resizedImage = await resizeImage(config)
      this.alimentare_imagine_noua = resizedImage;
      this.alimentare_este_document = 'pregatit';
    },
    pre_save: async function(){
        const panou = document.getElementById("loading");
        panou.style.display = 'flex';
        var rez = true
        let fc_ = this.fcs[this.fc_index] 
        try{
          const formData = {id: fc_.id,
            index_out: fc_.index_out, rezervor_in: this.valoareIntreaga(fc_.rezervor_in), rezervor_out: this.valoareIntreaga(fc_.rezervor_out),
            detalii_executie: fc_.detalii_executie, fct_motor: fc_.fct_motor}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.aplicaRaspunsFc(data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
          rez = false
        }
      panou.style.display = 'none'
      return rez
    },

    remorca_save: async function(){
      if (!this.fcActual?.faz || !this.remorca?.id) return;
      const panou = document.getElementById("loading");
      panou.style.display = 'flex';
      let fc_ = this.fcs[this.fc_index]
      try{
        const formData = {id: fc_.id, remorcax: this.remorca.id}
        const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
        const data = resp.data;
        if (data.ANS==='OK'){
            this.aplicaRaspunsFc(data.fc);
            this.actualizeazaFavoriteLocale('remorci', [this.remorca]);
            this.incarcaTaxe(fc_.id);
          }
        else{
          alert(data.MSG)
        }

      }catch(e){
        console.log(e)
      }
      panou.style.display = 'none'
      this.setare_remorca = false;
    },

    remorca_delete: async function(){
      if (!this.fcActual?.faz) return;
      if(confirm(`Stergeți remorca de la ${this.fcs[this.fc_index].utilaj__inventar}?`)){
        const panou = document.getElementById("loading");
        panou.style.display = 'flex';
        let fc_ = this.fcs[this.fc_index]
        try{
          const formData = {id: fc_.id, remorcax: null}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.aplicaRaspunsFc(data.fc);
              this.incarcaTaxe(fc_.id);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
        this.setare_remorca = false;
      }
    },

    check_alimentare: async function () {
      let fc_ = this.fcs[this.fc_index]
      //const panou = document.getElementById("loading");
      //panou.style.display = 'flex';
      let inc = document.getElementById('incarcare')
          inc.classList.add('is-active')
      var raspuns = false
      try {
        const resp = await axi.get(`rest_fc_faz_ask_alimentare/${fc_.id}/`)
        const data = resp.data
        if ((data.ANS === 'OK') && (data.alimcis_list.length > 0)) {
          let na = data.alimcis_list[0]
          if (confirm(`Ati alimentat ${na.alimentare.toFixed(0)} litri de la ${na.cisterna} cu bon nr: ${na.bon}. Acesta alimentare doriti sa o adaugati la fc?`)) {
            const rresp = await axi.post('rest_fc_faz_confirm_alimentare/', {fc: fc_.id, alimcis: na.id})
            const rdata = rresp.data
            if (rdata.ANS === 'OK') {
              this.aplicaRaspunsFc(rdata.fc)
              this.$forceUpdate()
            } else {
              alert(rdata.MSG)
            }  
            raspuns = true
          }
        }
      } catch (e) {
        console.log(e)
      }
      //panou.style.display = 'none'
      inc.classList.remove('is-active')  
      return raspuns
    },

    alimentare_save: async function(){
      let inc = document.getElementById('incarcare')
          inc.classList.add('is-active')
    
        try{
          const formData = new FormData();
          formData.append('fc', this.alimentare_fc);
          formData.append('alimentare', this.valoareCuMaxDouaZecimale(this.alimentare_litri));
          formData.append('furnizor', this.alimentare_de_la);
          formData.append('interes_personal', this.alimentare_interes_personal ? 'true' : 'false');
          if (this.alimentare_imagine_noua)
            formData.append('imagine', this.alimentare_imagine_noua, "bon_nou.jpeg" );
          let resp;
          if (this.alim_id==null)
            resp = await axi.post(`rest_fc_faz_add_alimentare/`, formData)
          else
            resp = await axi.put(`rest_fc_faz_put_alimentare/${this.alim_id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.aplicaRaspunsFc(data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        this.selecteaza_inginer = false
        //panou.style.display = 'none'
        inc.classList.remove('is-active')  

      this.alim_edit = false;
    },

    alimentare_sterge: async function(){
      if(confirm(`Sigur stergeti alimentarea de ${this.alimentare_litri} de la ${this.alimentare_de_la}?`)){
        //const panou = document.getElementById("loading");
        //panou.style.display = 'flex';
        let inc = document.getElementById('incarcare')
        inc.classList.add('is-active')
        
        try{
          const  resp = await axi.delete(`rest_fc_faz_delete_alimentare/${this.alim_id}/`)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.aplicaRaspunsFc(data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          alert(e)
          console.log(e)
        }
        this.selecteaza_inginer = false
        //panou.style.display = 'none'
        inc.classList.remove('is-active')  
      }

      this.alim_edit = false;
    },
    alimentare_show: function(alimentare){
      this.alimentare_litri = alimentare.alimentare;
      this.alimentare_de_la = alimentare.furnizor;
      this.alimentare_interes_personal = alimentare.interes_personal === true || alimentare.interes_personal === 'true' || alimentare.interes_personal === 1 || alimentare.interes_personal === '1';
      this.alimentare_este_document = 'OK';
      this.alimentare_fc = this.fcs[this.fc_index].id;
      this.alim_id =alimentare.id;
      this.alimentare_imagine_noua = null;
      this.alimentare_imagine = alimentare.imagine;
      //TODO:
      //Sa nu uiti de imagine  alimentare.imagine
      this.alim_edit = !this.alim_edit;
    },
    alimentare_add: async function () {
      await this.pre_save()
      let iesi = await this.check_alimentare()
      if (iesi) {
        return
      }
      this.alimentare_litri = '';
      this.alimentare_de_la = '';
      this.alimentare_interes_personal = false;
      this.alimentare_este_document = 'nu';
      this.alimentare_fc = this.fcs[this.fc_index].id;
      this.alim_id = null;
      this.alimentare_imagine_noua = null;
      this.alimentare_imagine = null;
      //TODO:
      //Sa nu uiti de imagine
      this.alim_edit = true;
    },

    alimentare_close: function(){
      this.alim_edit = false;
    },

    arata_cursa: function (cursa) {
      if (cursa == -1) {
        this.traseu_id = null;
        this.traseu_plecare = '';
        this.traseu_sosire = '';
        this.traseu_km_gol = 0;
        this.traseu_ckm_gol = 0;
        this.traseu_km_plin = 0;
        this.traseu_ckm_plin = 0;
        this.traseu_detalii_transport = '';
        this.traseu_cantitate = 0;
        this.traseu_tip_incarcatura = '';
        this.traseu_nr_curse = 1;
        this.traseu_basculari = 0;
        this.traseu_cbasculari = 0;
      } else {
        const tr = this.fcs[this.fc_index].transp[cursa];
        this.traseu_id = tr.id;
        this.traseu_plecare = tr.plecare;
        this.traseu_sosire = tr.sosire;
        this.traseu_km_gol = tr.km_gol;
        this.traseu_ckm_gol = tr.ckm_gol;
        this.traseu_km_plin = tr.km_plin;
        this.traseu_ckm_plin = tr.ckm_plin;
        this.traseu_detalii_transport = tr.detalii_transport;
        this.traseu_cantitate = tr.cantitate;
        this.traseu_tip_incarcatura = tr.tip_incarcatura;
        this.traseu_nr_curse = tr.nr_curse;
        this.traseu_basculari = tr.basculari;
        this.traseu_cbasculari = tr.cbasculari;
      }
      this.traseu_edit = true;
    },

    traseu_close: function () {
      this.traseu_edit = false;
    },

    traseu_sterge: async function () {
      if (!this.traseu_id) return;
      if (confirm(`Sigur stergeti traseul?`)) {
        let inc = document.getElementById('incarcare')
        inc.classList.add('is-active')

        try {
          const resp = await axi.delete(`rest_fc_faz_delete_transport/${this.traseu_id}/`)
          const data = resp.data;
          if (data.ANS === 'OK') {
            this.aplicaRaspunsFc(data.fc);
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          alert(e)
          console.log(e)
        }
        
        inc.classList.remove('is-active')
      }

      this.traseu_edit = false;
    },

    traseu_save: async function () {
      let inc = document.getElementById('incarcare')
      inc.classList.add('is-active')

      try {
        const formData = {
          plecare: this.traseu_plecare, sosire: this.traseu_sosire,
          km_gol: this.traseu_km_gol, ckm_gol: this.traseu_ckm_gol,
          km_plin: this.traseu_km_plin, ckm_plin: this.traseu_ckm_plin,
          detalii_transport: this.traseu_detalii_transport,
          cantitate: this.traseu_cantitate, tip_incarcatura: this.traseu_tip_incarcatura,
          nr_curse: this.traseu_nr_curse, fc: this.fcs[this.fc_index].id,
          basculari: this.traseu_basculari
        }
        let resp;
        if (this.traseu_id == null)
          resp = await axi.post(`rest_fc_faz_add_transport/`, formData)
        else
          resp = await axi.put(`rest_fc_faz_put_transport/${this.traseu_id}/`, formData)
        const data = resp.data;
        if (data.ANS === 'OK') {
          this.aplicaRaspunsFc(data.fc);
        }
        else {
          alert(data.MSG)
        }

      } catch (e) {
        console.log(e)
      }
      inc.classList.remove('is-active')

      this.traseu_edit = false;
    },
    traseu_tip_incarcatura_selectat: function (tip) {
      this.traseu_tip_incarcatura = tip[0];
    },
    ore_max: function () {
      return ['Compresor', 'Generator', 'Nacela', 'Placa compactoare', 'Pompa'].includes(this.fcs[this.fc_index].utilaj__tip) ? 720 : 24; 
    },

    lucrare_save: async function () {
      let inc = document.getElementById('incarcare')
      inc.classList.add('is-active')

      try {
        const formData = {
          fc: this.fcs[this.fc_index].id,
          ulei_motor: this.ulei_motor, filtru_ulei_motor: this.filtru_ulei_motor,
          filtru_combustibil: this.filtru_combustibil, filtru_aer: this.filtru_aer,
          filtru_polen: this.filtru_polen, filtru_adblue: this.filtru_adblue, filtru_uscator: this.filtru_uscator,
          ulei_cutie: this.ulei_cutie, filtru_ulei_cutie: this.filtru_ulei_cutie,
          ulei_punte: this.ulei_punte,
          ulei_hidraulic: this.ulei_hidraulic, filtru_ulei_hidraulic: this.filtru_ulei_hidraulic,
          lucrare_detalii : this.lucrare_detalii,
        }
        let resp;
        if (this.fcs[this.fc_index].lucrare == null)
          resp = await axi.post(`rest_fc_faz_add_lucrarefc/`, formData)
        else
          resp = await axi.put(`rest_fc_faz_put_lucrarefc/${this.fcs[this.fc_index].lucrare.id}/`, formData)
        const data = resp.data;
        if (data.ANS === 'OK') {
          this.aplicaRaspunsFc(data.fc);
        }
        else {
          alert(data.MSG)
        }

      } catch (e) {
        console.log(e)
      }
      inc.classList.remove('is-active')

      this.lucrare_edit = false;
      
    },

    editeaza_lucrare: function () {
      const lu = this.fcs[this.fc_index].lucrare
      if (lu != null){ 
        this.ulei_motor = lu.ulei_motor;
        this.filtru_ulei_motor = lu.filtru_ulei_motor;
        this.filtru_combustibil = lu.filtru_combustibil;
        this.filtru_aer = lu.filtru_aer;
        this.filtru_polen = lu.filtru_polen;
        this.filtru_adblue = lu.filtru_adblue;
        this.filtru_uscator = lu.filtru_uscator;
        this.ulei_cutie = lu.ulei_cutie;
        this.filtru_ulei_cutie = lu.filtru_ulei_cutie;
        this.ulei_punte = lu.ulei_punte;
        this.ulei_hidraulic = lu.ulei_hidraulic;
        this.filtru_ulei_hidraulic = lu.filtru_ulei_hidraulic;
        this.lucrare_detalii = lu.lucrare_detalii;
      }else{
        this.ulei_motor = false;
        this.filtru_ulei_motor = false;
        this.filtru_combustibil = false;
        this.filtru_aer = false;
        this.filtru_polen = false;
        this.filtru_adblue = false;
        this.filtru_uscator = false;
        this.ulei_cutie = false;
        this.filtru_ulei_cutie = false;
        this.ulei_punte = false;
        this.ulei_hidraulic = false;
        this.filtru_ulei_hidraulic = false;
        this.lucrare_detalii = "";
      }
      this.lucrare_edit = true;
    },

    lucrare_close: function () {
      this.lucrare_edit = false;
    },

    lucrare_sterge: async function () {
      // TODO: modifica aici functia
      if (!this.fcs[this.fc_index].lucrare) return;
      if (confirm(`Sigur stergeti schimburile / lucrarile ?`)) {
        let inc = document.getElementById('incarcare')
        inc.classList.add('is-active')

        try {
          
          const resp = await axi.delete(`rest_fc_faz_delete_lucrarefc/${this.fcs[this.fc_index].lucrare.id}/`)
          const data = resp.data;
          if (data.ANS === 'OK') {
            this.aplicaRaspunsFc(data.fc);
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          alert(e)
          console.log(e)
        }

        inc.classList.remove('is-active')
      }

      this.lucrare_edit = false;
    },

  }


  
}
</script>

<style scoped>
.home-action-grid {
  width: 268px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.home-action-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px 8px;
}

.planner-button {
  grid-column: 1 / -1;
  display: block;
  background-color: #ff902b;
  border-color: #ff902b;
  color: #fff;
}

.planner-button:hover,
.planner-button:focus {
  background-color: #e77b18;
  border-color: #e77b18;
  color: #fff;
}

.planner-button:focus-visible {
  outline: 2px solid #2c3e50;
  outline-offset: 2px;
}

.pagination {
  flex-wrap: wrap;
}

.pagination .page-item {
  margin-bottom: 0.25rem;
}

.pagination .page-link {
  white-space: nowrap;
}

.alimentari-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
}

.alimentari-wrap .btn {
  white-space: nowrap;
}

.alimentari-add-btn {
  margin-left: auto;
}

.instructions-button {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 120;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.video-modal {
  position: fixed;
  inset: 0;
  z-index: 150;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.88);
}

.video-modal-window {
  position: relative;
  width: min(960px, 100%);
  padding: 16px;
  border-radius: 12px;
  background: #111;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);
}

.video-modal-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.video-modal-close:hover,
.video-modal-close:focus {
    background: rgba(255, 255, 255, 0.16);
  }

  .video-player {
    display: block;
    width: 100%;
    max-height: 70vh;
    border-radius: 8px;
    background: #000;
  }

.video-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
}

.flex-box-2 {
  display:flex;
  justify-content: space-between;
  align-content: center;
  outline: 2px rgb(66, 63, 65) none;
  background-color: aliceblue;
  margin-bottom:0.3em;
}

.plus-squared {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktcGx1cy1zcXVhcmUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTE0IDFhMSAxIDAgMCAxIDEgMXYxMmExIDEgMCAwIDEtMSAxSDJhMSAxIDAgMCAxLTEtMVYyYTEgMSAwIDAgMSAxLTFoMTJ6TTIgMGEyIDIgMCAwIDAtMiAydjEyYTIgMiAwIDAgMCAyIDJoMTJhMiAyIDAgMCAwIDItMlYyYTIgMiAwIDAgMC0yLTJIMnoiLz4KICA8cGF0aCBkPSJNOCA0YS41LjUgMCAwIDEgLjUuNXYzaDNhLjUuNSAwIDAgMSAwIDFoLTN2M2EuNS41IDAgMCAxLTEgMHYtM2gtM2EuNS41IDAgMCAxIDAtMWgzdi0zQS41LjUgMCAwIDEgOCA0eiIvPgo8L3N2Zz4=");
}

/* The Modal (background) */
  .modall {
    display: block;
    /* Hidden by default */
    position: absolute;
    /* Stay in place */
    z-index: 10;
    /* Sit on top */
    padding-top: 100px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
  }

  /* Modal Content (image) */
  .modall-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
  }

    /* Caption of Modal Image */
  #caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 60px;
  }

  /* Add Animation */
  .modall-content,
  #caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
  }

  @-webkit-keyframes zoom {
    from {
      -webkit-transform: scale(0)
    }

    to {
      -webkit-transform: scale(1)
    }
  }

  @keyframes zoom {
    from {
      transform: scale(0)
    }

    to {
      transform: scale(1)
    }
  }

  /* The Close Button */
  .close {
    position: absolute;
    top: 12px;
    right: 12px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    padding: 10px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.16);
  }

   /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px) {
    .modal-content {
      width: 100%;
    }

    .video-modal-window {
      padding: 12px;
    }

    .instructions-button {
      right: 12px;
      bottom: 12px;
    }

    .video-player {
      max-height: 55vh;
    }

    .video-actions {
      flex-wrap: wrap;
    }

    /*signature pad css  */
    .wrapper {
      position: relative;
      width: 400px;
      height: 200px;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    img .sig {
      position: absolute;
      left: 0;
      top: 0;
    }

    .signature-pad {
      position: absolute;
      left: 0;
      top: 0;
      width: 400px;
      height: 200px;
      background-color: gray;
    }

    .svg-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-wrench" viewBox="0 0 16 16"><path d="M.102 2.223A3.004 3.004 0 0 0 3.78 5.897l6.341 6.252A3.003 3.003 0 0 0 13 16a3 3 0 1 0-.851-5.878L5.897 3.781A3.004 3.004 0 0 0 2.223.1l2.141 2.142L4 4l-1.757.364L.102 2.223zm13.37 9.019.528.026.287.445.445.287.026.529L15 13l-.242.471-.026.529-.445.287-.287.445-.529.026L13 15l-.471-.242-.529-.026-.287-.445-.445-.287-.026-.529L11 13l.242-.471.026-.529.445-.287.287-.445.529-.026L13 11l.471.242z"/></svg>');
      background-size: cover;
    }

  }

</style>
